export default {
    "province": [{
            "ssqid": "110000",
            "ssqname": "北京",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "110100",
                        "ssqname": "市辖区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "110101",
                                    "ssqname": "东城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110102",
                                    "ssqname": "西城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110103",
                                    "ssqname": "崇文区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110104",
                                    "ssqname": "宣武区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110105",
                                    "ssqname": "朝阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110106",
                                    "ssqname": "丰台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110107",
                                    "ssqname": "石景山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110108",
                                    "ssqname": "海淀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110109",
                                    "ssqname": "门头沟区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110111",
                                    "ssqname": "房山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110112",
                                    "ssqname": "通州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110113",
                                    "ssqname": "顺义区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110114",
                                    "ssqname": "昌平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110115",
                                    "ssqname": "大兴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110116",
                                    "ssqname": "平谷区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110117",
                                    "ssqname": "怀柔区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "110200",
                        "ssqname": "市辖县",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "110228",
                                    "ssqname": "密云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "110229",
                                    "ssqname": "延庆县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "120000",
            "ssqname": "天津",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "120100",
                        "ssqname": "市辖区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "120101",
                                    "ssqname": "和平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120102",
                                    "ssqname": "河东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120103",
                                    "ssqname": "河西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120104",
                                    "ssqname": "南开区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120105",
                                    "ssqname": "河北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120106",
                                    "ssqname": "红桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120107",
                                    "ssqname": "塘沽区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120108",
                                    "ssqname": "汉沽区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120109",
                                    "ssqname": "大港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120110",
                                    "ssqname": "东丽区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120111",
                                    "ssqname": "西青区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120112",
                                    "ssqname": "津南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120113",
                                    "ssqname": "北辰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120114",
                                    "ssqname": "武清区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120115",
                                    "ssqname": "宝坻区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "120200",
                        "ssqname": "市辖县",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "120221",
                                    "ssqname": "宁河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120223",
                                    "ssqname": "静海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "120225",
                                    "ssqname": "蓟县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "130000",
            "ssqname": "河北省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "130100",
                        "ssqname": "石家庄市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130102",
                                    "ssqname": "长安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130103",
                                    "ssqname": "桥东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130104",
                                    "ssqname": "桥西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130105",
                                    "ssqname": "新华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130107",
                                    "ssqname": "井陉矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130108",
                                    "ssqname": "裕华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130121",
                                    "ssqname": "井陉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130123",
                                    "ssqname": "正定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130124",
                                    "ssqname": "栾城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130125",
                                    "ssqname": "行唐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130126",
                                    "ssqname": "灵寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130127",
                                    "ssqname": "高邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130128",
                                    "ssqname": "深泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130129",
                                    "ssqname": "赞皇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130130",
                                    "ssqname": "无极县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130131",
                                    "ssqname": "平山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130132",
                                    "ssqname": "元氏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130133",
                                    "ssqname": "赵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130181",
                                    "ssqname": "辛集市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130182",
                                    "ssqname": "藁城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130183",
                                    "ssqname": "晋州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130184",
                                    "ssqname": "新乐市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130185",
                                    "ssqname": "鹿泉市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130200",
                        "ssqname": "唐山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130202",
                                    "ssqname": "路南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130203",
                                    "ssqname": "路北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130204",
                                    "ssqname": "古冶区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130205",
                                    "ssqname": "开平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130206",
                                    "ssqname": "新区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130221",
                                    "ssqname": "丰润县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130223",
                                    "ssqname": "滦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130224",
                                    "ssqname": "滦南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130225",
                                    "ssqname": "乐亭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130227",
                                    "ssqname": "迁西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130229",
                                    "ssqname": "玉田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130230",
                                    "ssqname": "唐海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130281",
                                    "ssqname": "遵化市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130282",
                                    "ssqname": "丰南市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130283",
                                    "ssqname": "迁安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130300",
                        "ssqname": "秦皇岛市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130302",
                                    "ssqname": "海港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130303",
                                    "ssqname": "山海关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130304",
                                    "ssqname": "北戴河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130321",
                                    "ssqname": "青龙满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130322",
                                    "ssqname": "昌黎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130323",
                                    "ssqname": "抚宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130324",
                                    "ssqname": "卢龙县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130400",
                        "ssqname": "邯郸市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130402",
                                    "ssqname": "邯山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130403",
                                    "ssqname": "丛台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130404",
                                    "ssqname": "复兴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130406",
                                    "ssqname": "峰峰矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130421",
                                    "ssqname": "邯郸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130423",
                                    "ssqname": "临漳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130424",
                                    "ssqname": "成安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130425",
                                    "ssqname": "大名县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130426",
                                    "ssqname": "涉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130427",
                                    "ssqname": "磁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130428",
                                    "ssqname": "肥乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130429",
                                    "ssqname": "永年县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130430",
                                    "ssqname": "邱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130431",
                                    "ssqname": "鸡泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130432",
                                    "ssqname": "广平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130433",
                                    "ssqname": "馆陶县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130434",
                                    "ssqname": "魏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130435",
                                    "ssqname": "曲周县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130481",
                                    "ssqname": "武安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130500",
                        "ssqname": "邢台市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130502",
                                    "ssqname": "桥东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130503",
                                    "ssqname": "桥西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130521",
                                    "ssqname": "邢台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130522",
                                    "ssqname": "临城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130523",
                                    "ssqname": "内丘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130524",
                                    "ssqname": "柏乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130525",
                                    "ssqname": "隆尧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130526",
                                    "ssqname": "任县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130527",
                                    "ssqname": "南和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130528",
                                    "ssqname": "宁晋县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130529",
                                    "ssqname": "巨鹿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130530",
                                    "ssqname": "新河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130531",
                                    "ssqname": "广宗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130532",
                                    "ssqname": "平乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130533",
                                    "ssqname": "威县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130534",
                                    "ssqname": "清河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130535",
                                    "ssqname": "临西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130581",
                                    "ssqname": "南宫市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130582",
                                    "ssqname": "沙河市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130600",
                        "ssqname": "保定市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130602",
                                    "ssqname": "新市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130603",
                                    "ssqname": "北市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130604",
                                    "ssqname": "南市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130621",
                                    "ssqname": "满城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130622",
                                    "ssqname": "清苑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130623",
                                    "ssqname": "涞水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130624",
                                    "ssqname": "阜平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130625",
                                    "ssqname": "徐水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130626",
                                    "ssqname": "定兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130627",
                                    "ssqname": "唐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130628",
                                    "ssqname": "高阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130629",
                                    "ssqname": "容城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130630",
                                    "ssqname": "涞源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130631",
                                    "ssqname": "望都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130632",
                                    "ssqname": "安新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130633",
                                    "ssqname": "易县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130634",
                                    "ssqname": "曲阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130635",
                                    "ssqname": "蠡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130636",
                                    "ssqname": "顺平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130637",
                                    "ssqname": "博野县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130638",
                                    "ssqname": "雄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130681",
                                    "ssqname": "涿州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130682",
                                    "ssqname": "定州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130683",
                                    "ssqname": "安国市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130684",
                                    "ssqname": "高碑店市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130700",
                        "ssqname": "张家口市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130702",
                                    "ssqname": "桥东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130703",
                                    "ssqname": "桥西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130705",
                                    "ssqname": "宣化区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130706",
                                    "ssqname": "下花园区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130721",
                                    "ssqname": "宣化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130722",
                                    "ssqname": "张北县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130723",
                                    "ssqname": "康保县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130724",
                                    "ssqname": "沽源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130725",
                                    "ssqname": "尚义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130726",
                                    "ssqname": "蔚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130727",
                                    "ssqname": "阳原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130728",
                                    "ssqname": "怀安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130729",
                                    "ssqname": "万全县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130730",
                                    "ssqname": "怀来县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130731",
                                    "ssqname": "涿鹿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130732",
                                    "ssqname": "赤城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130733",
                                    "ssqname": "崇礼县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130800",
                        "ssqname": "承德市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130802",
                                    "ssqname": "双桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130803",
                                    "ssqname": "双滦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130804",
                                    "ssqname": "鹰手营子矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130821",
                                    "ssqname": "承德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130822",
                                    "ssqname": "兴隆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130823",
                                    "ssqname": "平泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130824",
                                    "ssqname": "滦平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130825",
                                    "ssqname": "隆化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130826",
                                    "ssqname": "丰宁满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130827",
                                    "ssqname": "宽城满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130828",
                                    "ssqname": "围场满族蒙古族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "130900",
                        "ssqname": "沧州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "130902",
                                    "ssqname": "新华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130903",
                                    "ssqname": "运河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130921",
                                    "ssqname": "沧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130922",
                                    "ssqname": "青县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130923",
                                    "ssqname": "东光县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130924",
                                    "ssqname": "海兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130925",
                                    "ssqname": "盐山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130926",
                                    "ssqname": "肃宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130927",
                                    "ssqname": "南皮县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130928",
                                    "ssqname": "吴桥县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130929",
                                    "ssqname": "献县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130930",
                                    "ssqname": "孟村回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130981",
                                    "ssqname": "泊头市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130982",
                                    "ssqname": "任丘市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130983",
                                    "ssqname": "黄骅市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "130984",
                                    "ssqname": "河间市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "131000",
                        "ssqname": "廊坊市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "131002",
                                    "ssqname": "安次区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131003",
                                    "ssqname": "广阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131022",
                                    "ssqname": "固安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131023",
                                    "ssqname": "永清县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131024",
                                    "ssqname": "香河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131025",
                                    "ssqname": "大城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131026",
                                    "ssqname": "文安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131028",
                                    "ssqname": "大厂回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131081",
                                    "ssqname": "霸州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131082",
                                    "ssqname": "三河市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "131100",
                        "ssqname": "衡水市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "131102",
                                    "ssqname": "桃城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131121",
                                    "ssqname": "枣强县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131122",
                                    "ssqname": "武邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131123",
                                    "ssqname": "武强县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131124",
                                    "ssqname": "饶阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131125",
                                    "ssqname": "安平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131126",
                                    "ssqname": "故城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131127",
                                    "ssqname": "景县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131128",
                                    "ssqname": "阜城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131181",
                                    "ssqname": "冀州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "131182",
                                    "ssqname": "深州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "140000",
            "ssqname": "山西省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "140100",
                        "ssqname": "太原市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140105",
                                    "ssqname": "小店区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140106",
                                    "ssqname": "迎泽区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140107",
                                    "ssqname": "杏花岭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140108",
                                    "ssqname": "尖草坪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140109",
                                    "ssqname": "万柏林区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140110",
                                    "ssqname": "晋源区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140121",
                                    "ssqname": "清徐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140122",
                                    "ssqname": "阳曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140123",
                                    "ssqname": "娄烦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140181",
                                    "ssqname": "古交市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140200",
                        "ssqname": "大同市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140202",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140203",
                                    "ssqname": "矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140211",
                                    "ssqname": "南郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140212",
                                    "ssqname": "新荣区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140221",
                                    "ssqname": "阳高县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140222",
                                    "ssqname": "天镇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140223",
                                    "ssqname": "广灵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140224",
                                    "ssqname": "灵丘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140225",
                                    "ssqname": "浑源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140226",
                                    "ssqname": "左云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140227",
                                    "ssqname": "大同县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140300",
                        "ssqname": "阳泉市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140302",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140303",
                                    "ssqname": "矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140311",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140321",
                                    "ssqname": "平定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140322",
                                    "ssqname": "盂县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140400",
                        "ssqname": "长治市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140402",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140411",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140421",
                                    "ssqname": "长治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140423",
                                    "ssqname": "襄垣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140424",
                                    "ssqname": "屯留县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140425",
                                    "ssqname": "平顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140426",
                                    "ssqname": "黎城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140427",
                                    "ssqname": "壶关县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140428",
                                    "ssqname": "长子县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140429",
                                    "ssqname": "武乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140430",
                                    "ssqname": "沁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140431",
                                    "ssqname": "沁源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140481",
                                    "ssqname": "潞城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140500",
                        "ssqname": "晋城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140502",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140521",
                                    "ssqname": "沁水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140522",
                                    "ssqname": "阳城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140524",
                                    "ssqname": "陵川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140525",
                                    "ssqname": "泽州县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140581",
                                    "ssqname": "高平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140600",
                        "ssqname": "朔州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140602",
                                    "ssqname": "朔城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140603",
                                    "ssqname": "平鲁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140621",
                                    "ssqname": "山阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140622",
                                    "ssqname": "应县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140623",
                                    "ssqname": "右玉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140624",
                                    "ssqname": "怀仁县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140700",
                        "ssqname": "晋中市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140702",
                                    "ssqname": "榆次区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140721",
                                    "ssqname": "榆社县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140722",
                                    "ssqname": "左权县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140723",
                                    "ssqname": "和顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140724",
                                    "ssqname": "昔阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140725",
                                    "ssqname": "寿阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140726",
                                    "ssqname": "太谷县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140727",
                                    "ssqname": "祁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140728",
                                    "ssqname": "平遥县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140729",
                                    "ssqname": "灵石县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140781",
                                    "ssqname": "介休市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140800",
                        "ssqname": "运城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140802",
                                    "ssqname": "盐湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140821",
                                    "ssqname": "临猗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140822",
                                    "ssqname": "万荣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140823",
                                    "ssqname": "闻喜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140824",
                                    "ssqname": "稷山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140825",
                                    "ssqname": "新绛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140826",
                                    "ssqname": "绛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140827",
                                    "ssqname": "垣曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140828",
                                    "ssqname": "夏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140829",
                                    "ssqname": "平陆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140830",
                                    "ssqname": "芮城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140881",
                                    "ssqname": "永济市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140882",
                                    "ssqname": "河津市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "140900",
                        "ssqname": "忻州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "140902",
                                    "ssqname": "忻府区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140921",
                                    "ssqname": "定襄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140922",
                                    "ssqname": "五台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140923",
                                    "ssqname": "代县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140924",
                                    "ssqname": "繁峙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140925",
                                    "ssqname": "宁武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140926",
                                    "ssqname": "静乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140927",
                                    "ssqname": "神池县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140928",
                                    "ssqname": "五寨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140929",
                                    "ssqname": "岢岚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140930",
                                    "ssqname": "河曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140931",
                                    "ssqname": "保德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140932",
                                    "ssqname": "偏关县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "140981",
                                    "ssqname": "原平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "141000",
                        "ssqname": "临汾市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "141002",
                                    "ssqname": "尧都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141021",
                                    "ssqname": "曲沃县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141022",
                                    "ssqname": "翼城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141023",
                                    "ssqname": "襄汾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141024",
                                    "ssqname": "洪洞县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141025",
                                    "ssqname": "古县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141026",
                                    "ssqname": "安泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141027",
                                    "ssqname": "浮山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141028",
                                    "ssqname": "吉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141029",
                                    "ssqname": "乡宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141030",
                                    "ssqname": "大宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141031",
                                    "ssqname": "隰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141032",
                                    "ssqname": "永和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141033",
                                    "ssqname": "蒲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141034",
                                    "ssqname": "汾西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141081",
                                    "ssqname": "侯马市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "141082",
                                    "ssqname": "霍州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "142300",
                        "ssqname": "吕梁地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "142301",
                                    "ssqname": "孝义市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142302",
                                    "ssqname": "离石市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142303",
                                    "ssqname": "汾阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142322",
                                    "ssqname": "文水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142323",
                                    "ssqname": "交城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142325",
                                    "ssqname": "兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142326",
                                    "ssqname": "临县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142327",
                                    "ssqname": "柳林县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142328",
                                    "ssqname": "石楼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142329",
                                    "ssqname": "岚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142330",
                                    "ssqname": "方山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142332",
                                    "ssqname": "中阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "142333",
                                    "ssqname": "交口县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "150000",
            "ssqname": "内蒙古",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "150100",
                        "ssqname": "呼和浩特市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150102",
                                    "ssqname": "新城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150103",
                                    "ssqname": "回民区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150104",
                                    "ssqname": "玉泉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150105",
                                    "ssqname": "赛罕区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150121",
                                    "ssqname": "土默特左旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150122",
                                    "ssqname": "托克托县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150123",
                                    "ssqname": "和林格尔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150124",
                                    "ssqname": "清水河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150125",
                                    "ssqname": "武川县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150200",
                        "ssqname": "包头市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150202",
                                    "ssqname": "东河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150203",
                                    "ssqname": "昆都仑区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150204",
                                    "ssqname": "青山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150205",
                                    "ssqname": "石拐区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150206",
                                    "ssqname": "白云矿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150207",
                                    "ssqname": "九原区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150221",
                                    "ssqname": "土默特右旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150222",
                                    "ssqname": "固阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150223",
                                    "ssqname": "达尔罕茂明安联合旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150300",
                        "ssqname": "乌海市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150302",
                                    "ssqname": "海勃湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150303",
                                    "ssqname": "海南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150304",
                                    "ssqname": "乌达区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150400",
                        "ssqname": "赤峰市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150402",
                                    "ssqname": "红山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150403",
                                    "ssqname": "元宝山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150404",
                                    "ssqname": "松山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150421",
                                    "ssqname": "阿鲁科尔沁旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150422",
                                    "ssqname": "巴林左旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150423",
                                    "ssqname": "巴林右旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150424",
                                    "ssqname": "林西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150425",
                                    "ssqname": "克什克腾旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150426",
                                    "ssqname": "翁牛特旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150428",
                                    "ssqname": "喀喇沁旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150429",
                                    "ssqname": "宁城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150430",
                                    "ssqname": "敖汉旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150500",
                        "ssqname": "通辽市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150502",
                                    "ssqname": "科尔沁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150521",
                                    "ssqname": "科尔沁左翼中旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150522",
                                    "ssqname": "科尔沁左翼后旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150523",
                                    "ssqname": "开鲁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150524",
                                    "ssqname": "库伦旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150525",
                                    "ssqname": "奈曼旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150526",
                                    "ssqname": "扎鲁特旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150581",
                                    "ssqname": "霍林郭勒市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150600",
                        "ssqname": "鄂尔多斯市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150602",
                                    "ssqname": "东胜区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150621",
                                    "ssqname": "达拉特旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150622",
                                    "ssqname": "准格尔旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150623",
                                    "ssqname": "鄂托克前旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150624",
                                    "ssqname": "鄂托克旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150625",
                                    "ssqname": "杭锦旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150626",
                                    "ssqname": "乌审旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150627",
                                    "ssqname": "伊金霍洛旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "150700",
                        "ssqname": "呼伦贝尔市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "150702",
                                    "ssqname": "海拉尔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150721",
                                    "ssqname": "阿荣旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150722",
                                    "ssqname": "莫力达瓦达斡尔族自治旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150723",
                                    "ssqname": "鄂伦春自治旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150724",
                                    "ssqname": "鄂温克族自治旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150725",
                                    "ssqname": "陈巴尔虎旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150726",
                                    "ssqname": "新巴尔虎左旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150727",
                                    "ssqname": "新巴尔虎右旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150781",
                                    "ssqname": "满洲里市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150782",
                                    "ssqname": "牙克石市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150783",
                                    "ssqname": "扎兰屯市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150784",
                                    "ssqname": "额尔古纳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "150785",
                                    "ssqname": "根河市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "152200",
                        "ssqname": "兴安盟",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "152201",
                                    "ssqname": "乌兰浩特市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152202",
                                    "ssqname": "阿尔山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152221",
                                    "ssqname": "科尔沁右翼前旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152222",
                                    "ssqname": "科尔沁右翼中旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152223",
                                    "ssqname": "扎赉特旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152224",
                                    "ssqname": "突泉县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "152500",
                        "ssqname": "锡林郭勒盟",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "152501",
                                    "ssqname": "二连浩特市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152502",
                                    "ssqname": "锡林浩特市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152522",
                                    "ssqname": "阿巴嘎旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152523",
                                    "ssqname": "苏尼特左旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152524",
                                    "ssqname": "苏尼特右旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152525",
                                    "ssqname": "东乌珠穆沁旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152526",
                                    "ssqname": "西乌珠穆沁旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152527",
                                    "ssqname": "太仆寺旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152528",
                                    "ssqname": "镶黄旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152529",
                                    "ssqname": "正镶白旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152530",
                                    "ssqname": "正蓝旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152531",
                                    "ssqname": "多伦县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "152600",
                        "ssqname": "乌兰察布盟",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "152601",
                                    "ssqname": "集宁市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152602",
                                    "ssqname": "丰镇市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152624",
                                    "ssqname": "卓资县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152625",
                                    "ssqname": "化德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152626",
                                    "ssqname": "商都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152627",
                                    "ssqname": "兴和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152629",
                                    "ssqname": "凉城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152630",
                                    "ssqname": "察哈尔右翼前旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152631",
                                    "ssqname": "察哈尔右翼中旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152632",
                                    "ssqname": "察哈尔右翼后旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152634",
                                    "ssqname": "四子王旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "152800",
                        "ssqname": "巴彦淖尔盟",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "152801",
                                    "ssqname": "临河市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152822",
                                    "ssqname": "五原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152823",
                                    "ssqname": "磴口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152824",
                                    "ssqname": "乌拉特前旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152825",
                                    "ssqname": "乌拉特中旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152826",
                                    "ssqname": "乌拉特后旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152827",
                                    "ssqname": "杭锦后旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "152900",
                        "ssqname": "阿拉善盟",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "152921",
                                    "ssqname": "阿拉善左旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152922",
                                    "ssqname": "阿拉善右旗",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "152923",
                                    "ssqname": "额济纳旗",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "210000",
            "ssqname": "辽宁省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "210100",
                        "ssqname": "沈阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210102",
                                    "ssqname": "和平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210103",
                                    "ssqname": "沈河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210104",
                                    "ssqname": "大东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210105",
                                    "ssqname": "皇姑区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210106",
                                    "ssqname": "铁西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210111",
                                    "ssqname": "苏家屯区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210112",
                                    "ssqname": "东陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210113",
                                    "ssqname": "新城子区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210114",
                                    "ssqname": "于洪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210122",
                                    "ssqname": "辽中县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210123",
                                    "ssqname": "康平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210124",
                                    "ssqname": "法库县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210181",
                                    "ssqname": "新民市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210200",
                        "ssqname": "大连市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210202",
                                    "ssqname": "中山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210203",
                                    "ssqname": "西岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210204",
                                    "ssqname": "沙河口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210211",
                                    "ssqname": "甘井子区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210212",
                                    "ssqname": "旅顺口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210213",
                                    "ssqname": "金州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210224",
                                    "ssqname": "长海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210281",
                                    "ssqname": "瓦房店市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210282",
                                    "ssqname": "普兰店市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210283",
                                    "ssqname": "庄河市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210300",
                        "ssqname": "鞍山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210302",
                                    "ssqname": "铁东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210303",
                                    "ssqname": "铁西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210304",
                                    "ssqname": "立山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210311",
                                    "ssqname": "千山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210321",
                                    "ssqname": "台安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210323",
                                    "ssqname": "岫岩满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210381",
                                    "ssqname": "海城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210400",
                        "ssqname": "抚顺市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210402",
                                    "ssqname": "新抚区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210403",
                                    "ssqname": "东洲区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210404",
                                    "ssqname": "望花区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210411",
                                    "ssqname": "顺城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210421",
                                    "ssqname": "抚顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210422",
                                    "ssqname": "新宾满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210423",
                                    "ssqname": "清原满族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210500",
                        "ssqname": "本溪市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210502",
                                    "ssqname": "平山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210503",
                                    "ssqname": "溪湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210504",
                                    "ssqname": "明山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210505",
                                    "ssqname": "南芬区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210521",
                                    "ssqname": "本溪满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210522",
                                    "ssqname": "桓仁满族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210600",
                        "ssqname": "丹东市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210602",
                                    "ssqname": "元宝区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210603",
                                    "ssqname": "振兴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210604",
                                    "ssqname": "振安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210624",
                                    "ssqname": "宽甸满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210681",
                                    "ssqname": "东港市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210682",
                                    "ssqname": "凤城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210700",
                        "ssqname": "锦州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210702",
                                    "ssqname": "古塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210703",
                                    "ssqname": "凌河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210711",
                                    "ssqname": "太和区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210726",
                                    "ssqname": "黑山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210727",
                                    "ssqname": "义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210781",
                                    "ssqname": "凌海市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210782",
                                    "ssqname": "北宁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210800",
                        "ssqname": "营口市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210802",
                                    "ssqname": "站前区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210803",
                                    "ssqname": "西市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210804",
                                    "ssqname": "鲅鱼圈区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210811",
                                    "ssqname": "老边区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210881",
                                    "ssqname": "盖州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210882",
                                    "ssqname": "大石桥市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "210900",
                        "ssqname": "阜新市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "210902",
                                    "ssqname": "海州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210903",
                                    "ssqname": "新邱区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210904",
                                    "ssqname": "太平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210905",
                                    "ssqname": "清河门区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210911",
                                    "ssqname": "细河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210921",
                                    "ssqname": "阜新蒙古族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "210922",
                                    "ssqname": "彰武县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "211000",
                        "ssqname": "辽阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "211002",
                                    "ssqname": "白塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211003",
                                    "ssqname": "文圣区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211004",
                                    "ssqname": "宏伟区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211005",
                                    "ssqname": "弓长岭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211011",
                                    "ssqname": "太子河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211021",
                                    "ssqname": "辽阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211081",
                                    "ssqname": "灯塔市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "211100",
                        "ssqname": "盘锦市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "211102",
                                    "ssqname": "双台子区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211103",
                                    "ssqname": "兴隆台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211121",
                                    "ssqname": "大洼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211122",
                                    "ssqname": "盘山县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "211200",
                        "ssqname": "铁岭市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "211202",
                                    "ssqname": "银州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211204",
                                    "ssqname": "清河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211221",
                                    "ssqname": "铁岭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211223",
                                    "ssqname": "西丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211224",
                                    "ssqname": "昌图县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211281",
                                    "ssqname": "铁法市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211282",
                                    "ssqname": "开原市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "211300",
                        "ssqname": "朝阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "211302",
                                    "ssqname": "双塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211303",
                                    "ssqname": "龙城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211321",
                                    "ssqname": "朝阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211322",
                                    "ssqname": "建平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211324",
                                    "ssqname": "喀喇沁左翼蒙古族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211381",
                                    "ssqname": "北票市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211382",
                                    "ssqname": "凌源市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "211400",
                        "ssqname": "葫芦岛市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "211402",
                                    "ssqname": "连山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211403",
                                    "ssqname": "龙港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211404",
                                    "ssqname": "南票区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211421",
                                    "ssqname": "绥中县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211422",
                                    "ssqname": "建昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "211481",
                                    "ssqname": "兴城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "220000",
            "ssqname": "吉林省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "220100",
                        "ssqname": "长春市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220102",
                                    "ssqname": "南关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220103",
                                    "ssqname": "宽城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220104",
                                    "ssqname": "朝阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220105",
                                    "ssqname": "二道区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220106",
                                    "ssqname": "绿园区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220112",
                                    "ssqname": "双阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220122",
                                    "ssqname": "农安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220181",
                                    "ssqname": "九台市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220182",
                                    "ssqname": "榆树市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220183",
                                    "ssqname": "德惠市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220200",
                        "ssqname": "吉林市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220202",
                                    "ssqname": "昌邑区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220203",
                                    "ssqname": "龙潭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220204",
                                    "ssqname": "船营区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220211",
                                    "ssqname": "丰满区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220221",
                                    "ssqname": "永吉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220281",
                                    "ssqname": "蛟河市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220282",
                                    "ssqname": "桦甸市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220283",
                                    "ssqname": "舒兰市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220284",
                                    "ssqname": "磐石市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220300",
                        "ssqname": "四平市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220302",
                                    "ssqname": "铁西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220303",
                                    "ssqname": "铁东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220322",
                                    "ssqname": "梨树县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220323",
                                    "ssqname": "伊通满族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220381",
                                    "ssqname": "公主岭市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220382",
                                    "ssqname": "双辽市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220400",
                        "ssqname": "辽源市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220402",
                                    "ssqname": "龙山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220403",
                                    "ssqname": "西安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220421",
                                    "ssqname": "东丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220422",
                                    "ssqname": "东辽县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220500",
                        "ssqname": "通化市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220502",
                                    "ssqname": "东昌区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220503",
                                    "ssqname": "二道江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220521",
                                    "ssqname": "通化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220523",
                                    "ssqname": "辉南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220524",
                                    "ssqname": "柳河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220581",
                                    "ssqname": "梅河口市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220582",
                                    "ssqname": "集安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220600",
                        "ssqname": "白山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220602",
                                    "ssqname": "八道江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220621",
                                    "ssqname": "抚松县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220622",
                                    "ssqname": "靖宇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220623",
                                    "ssqname": "长白朝鲜族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220625",
                                    "ssqname": "江源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220681",
                                    "ssqname": "临江市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220700",
                        "ssqname": "松原市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220702",
                                    "ssqname": "宁江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220721",
                                    "ssqname": "前郭尔罗斯蒙古族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220722",
                                    "ssqname": "长岭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220723",
                                    "ssqname": "乾安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220724",
                                    "ssqname": "扶余县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "220800",
                        "ssqname": "白城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "220802",
                                    "ssqname": "洮北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220821",
                                    "ssqname": "镇赉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220822",
                                    "ssqname": "通榆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220881",
                                    "ssqname": "洮南市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "220882",
                                    "ssqname": "大安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "222400",
                        "ssqname": "延边朝鲜族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "222401",
                                    "ssqname": "延吉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222402",
                                    "ssqname": "图们市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222403",
                                    "ssqname": "敦化市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222404",
                                    "ssqname": "珲春市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222405",
                                    "ssqname": "龙井市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222406",
                                    "ssqname": "和龙市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222424",
                                    "ssqname": "汪清县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "222426",
                                    "ssqname": "安图县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "230000",
            "ssqname": "黑龙江省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "230100",
                        "ssqname": "哈尔滨市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230102",
                                    "ssqname": "道里区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230103",
                                    "ssqname": "南岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230104",
                                    "ssqname": "道外区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230105",
                                    "ssqname": "太平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230106",
                                    "ssqname": "香坊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230107",
                                    "ssqname": "动力区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230108",
                                    "ssqname": "平房区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230121",
                                    "ssqname": "呼兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230123",
                                    "ssqname": "依兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230124",
                                    "ssqname": "方正县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230125",
                                    "ssqname": "宾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230126",
                                    "ssqname": "巴彦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230127",
                                    "ssqname": "木兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230128",
                                    "ssqname": "通河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230129",
                                    "ssqname": "延寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230181",
                                    "ssqname": "阿城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230182",
                                    "ssqname": "双城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230183",
                                    "ssqname": "尚志市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230184",
                                    "ssqname": "五常市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230200",
                        "ssqname": "齐齐哈尔市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230202",
                                    "ssqname": "龙沙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230203",
                                    "ssqname": "建华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230204",
                                    "ssqname": "铁锋区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230205",
                                    "ssqname": "昂昂溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230206",
                                    "ssqname": "富拉尔基区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230207",
                                    "ssqname": "碾子山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230208",
                                    "ssqname": "梅里斯达斡尔族区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230221",
                                    "ssqname": "龙江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230223",
                                    "ssqname": "依安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230224",
                                    "ssqname": "泰来县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230225",
                                    "ssqname": "甘南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230227",
                                    "ssqname": "富裕县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230229",
                                    "ssqname": "克山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230230",
                                    "ssqname": "克东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230231",
                                    "ssqname": "拜泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230281",
                                    "ssqname": "讷河市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230300",
                        "ssqname": "鸡西市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230302",
                                    "ssqname": "鸡冠区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230303",
                                    "ssqname": "恒山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230304",
                                    "ssqname": "滴道区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230305",
                                    "ssqname": "梨树区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230306",
                                    "ssqname": "城子河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230307",
                                    "ssqname": "麻山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230321",
                                    "ssqname": "鸡东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230381",
                                    "ssqname": "虎林市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230382",
                                    "ssqname": "密山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230400",
                        "ssqname": "鹤岗市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230402",
                                    "ssqname": "向阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230403",
                                    "ssqname": "工农区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230404",
                                    "ssqname": "南山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230405",
                                    "ssqname": "兴安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230406",
                                    "ssqname": "东山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230407",
                                    "ssqname": "兴山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230421",
                                    "ssqname": "萝北县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230422",
                                    "ssqname": "绥滨县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230500",
                        "ssqname": "双鸭山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230502",
                                    "ssqname": "尖山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230503",
                                    "ssqname": "岭东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230505",
                                    "ssqname": "四方台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230506",
                                    "ssqname": "宝山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230521",
                                    "ssqname": "集贤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230522",
                                    "ssqname": "友谊县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230523",
                                    "ssqname": "宝清县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230524",
                                    "ssqname": "饶河县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230600",
                        "ssqname": "大庆市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230602",
                                    "ssqname": "萨尔图区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230603",
                                    "ssqname": "龙凤区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230604",
                                    "ssqname": "让胡路区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230605",
                                    "ssqname": "红岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230606",
                                    "ssqname": "大同区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230621",
                                    "ssqname": "肇州县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230622",
                                    "ssqname": "肇源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230623",
                                    "ssqname": "林甸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230624",
                                    "ssqname": "杜尔伯特蒙古族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230700",
                        "ssqname": "伊春市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230702",
                                    "ssqname": "伊春区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230703",
                                    "ssqname": "南岔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230704",
                                    "ssqname": "友好区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230705",
                                    "ssqname": "西林区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230706",
                                    "ssqname": "翠峦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230707",
                                    "ssqname": "新青区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230708",
                                    "ssqname": "美溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230709",
                                    "ssqname": "金山屯区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230710",
                                    "ssqname": "五营区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230711",
                                    "ssqname": "乌马河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230712",
                                    "ssqname": "汤旺河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230713",
                                    "ssqname": "带岭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230714",
                                    "ssqname": "乌伊岭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230715",
                                    "ssqname": "红星区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230716",
                                    "ssqname": "上甘岭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230722",
                                    "ssqname": "嘉荫县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230781",
                                    "ssqname": "铁力市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230800",
                        "ssqname": "佳木斯市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230802",
                                    "ssqname": "永红区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230803",
                                    "ssqname": "向阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230804",
                                    "ssqname": "前进区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230805",
                                    "ssqname": "东风区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230811",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230822",
                                    "ssqname": "桦南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230826",
                                    "ssqname": "桦川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230828",
                                    "ssqname": "汤原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230833",
                                    "ssqname": "抚远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230881",
                                    "ssqname": "同江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230882",
                                    "ssqname": "富锦市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "230900",
                        "ssqname": "七台河市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "230902",
                                    "ssqname": "新兴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230903",
                                    "ssqname": "桃山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230904",
                                    "ssqname": "茄子河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "230921",
                                    "ssqname": "勃利县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "231000",
                        "ssqname": "牡丹江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "231002",
                                    "ssqname": "东安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231003",
                                    "ssqname": "阳明区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231004",
                                    "ssqname": "爱民区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231005",
                                    "ssqname": "西安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231024",
                                    "ssqname": "东宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231025",
                                    "ssqname": "林口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231081",
                                    "ssqname": "绥芬河市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231083",
                                    "ssqname": "海林市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231084",
                                    "ssqname": "宁安市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231085",
                                    "ssqname": "穆棱市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "231100",
                        "ssqname": "黑河市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "231102",
                                    "ssqname": "爱辉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231121",
                                    "ssqname": "嫩江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231123",
                                    "ssqname": "逊克县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231124",
                                    "ssqname": "孙吴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231181",
                                    "ssqname": "北安市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231182",
                                    "ssqname": "五大连池市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "231200",
                        "ssqname": "绥化市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "231202",
                                    "ssqname": "北林区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231221",
                                    "ssqname": "望奎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231222",
                                    "ssqname": "兰西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231223",
                                    "ssqname": "青冈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231224",
                                    "ssqname": "庆安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231225",
                                    "ssqname": "明水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231226",
                                    "ssqname": "绥棱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231281",
                                    "ssqname": "安达市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231282",
                                    "ssqname": "肇东市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "231283",
                                    "ssqname": "海伦市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "232700",
                        "ssqname": "大兴安岭地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "232721",
                                    "ssqname": "呼玛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "232722",
                                    "ssqname": "塔河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "232723",
                                    "ssqname": "漠河县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "310000",
            "ssqname": "上海",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "310100",
                        "ssqname": "市辖区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "310101",
                                    "ssqname": "黄浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310103",
                                    "ssqname": "卢湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310104",
                                    "ssqname": "徐汇区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310105",
                                    "ssqname": "长宁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310106",
                                    "ssqname": "静安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310107",
                                    "ssqname": "普陀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310108",
                                    "ssqname": "闸北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310109",
                                    "ssqname": "虹口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310110",
                                    "ssqname": "杨浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310112",
                                    "ssqname": "闵行区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310113",
                                    "ssqname": "宝山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310114",
                                    "ssqname": "嘉定区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310115",
                                    "ssqname": "浦东新区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310116",
                                    "ssqname": "金山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310117",
                                    "ssqname": "松江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310118",
                                    "ssqname": "青浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310119",
                                    "ssqname": "南汇区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "310120",
                                    "ssqname": "奉贤区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "310200",
                        "ssqname": "市辖县",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "310230",
                                "ssqname": "崇明县",
                                "ssqename": ""
                            }]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "320000",
            "ssqname": "江苏省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "320100",
                        "ssqname": "南京市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320102",
                                    "ssqname": "玄武区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320103",
                                    "ssqname": "白下区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320104",
                                    "ssqname": "秦淮区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320105",
                                    "ssqname": "建邺区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320106",
                                    "ssqname": "鼓楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320107",
                                    "ssqname": "下关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320111",
                                    "ssqname": "浦口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320112",
                                    "ssqname": "大厂区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320113",
                                    "ssqname": "栖霞区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320114",
                                    "ssqname": "雨花台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320115",
                                    "ssqname": "江宁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320122",
                                    "ssqname": "江浦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320123",
                                    "ssqname": "六合县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320124",
                                    "ssqname": "溧水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320125",
                                    "ssqname": "高淳县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320200",
                        "ssqname": "无锡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320202",
                                    "ssqname": "崇安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320203",
                                    "ssqname": "南长区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320204",
                                    "ssqname": "北塘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320205",
                                    "ssqname": "锡山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320206",
                                    "ssqname": "惠山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320211",
                                    "ssqname": "滨湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320281",
                                    "ssqname": "江阴市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320282",
                                    "ssqname": "宜兴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320300",
                        "ssqname": "徐州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320302",
                                    "ssqname": "鼓楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320303",
                                    "ssqname": "云龙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320304",
                                    "ssqname": "九里区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320305",
                                    "ssqname": "贾汪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320311",
                                    "ssqname": "泉山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320321",
                                    "ssqname": "丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320322",
                                    "ssqname": "沛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320323",
                                    "ssqname": "铜山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320324",
                                    "ssqname": "睢宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320381",
                                    "ssqname": "新沂市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320382",
                                    "ssqname": "邳州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320400",
                        "ssqname": "常州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320402",
                                    "ssqname": "天宁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320404",
                                    "ssqname": "钟楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320405",
                                    "ssqname": "戚墅堰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320411",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320481",
                                    "ssqname": "溧阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320482",
                                    "ssqname": "金坛市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320483",
                                    "ssqname": "武进市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320500",
                        "ssqname": "苏州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320502",
                                    "ssqname": "沧浪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320503",
                                    "ssqname": "平江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320504",
                                    "ssqname": "金阊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320505",
                                    "ssqname": "虎丘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320506",
                                    "ssqname": "吴中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320507",
                                    "ssqname": "相城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320581",
                                    "ssqname": "常熟市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320582",
                                    "ssqname": "张家港市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320583",
                                    "ssqname": "昆山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320584",
                                    "ssqname": "吴江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320585",
                                    "ssqname": "太仓市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320600",
                        "ssqname": "南通市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320602",
                                    "ssqname": "崇川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320611",
                                    "ssqname": "港闸区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320621",
                                    "ssqname": "海安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320623",
                                    "ssqname": "如东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320681",
                                    "ssqname": "启东市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320682",
                                    "ssqname": "如皋市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320683",
                                    "ssqname": "通州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320684",
                                    "ssqname": "海门市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320700",
                        "ssqname": "连云港市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320703",
                                    "ssqname": "连云区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320705",
                                    "ssqname": "新浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320706",
                                    "ssqname": "海州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320721",
                                    "ssqname": "赣榆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320722",
                                    "ssqname": "东海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320723",
                                    "ssqname": "灌云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320724",
                                    "ssqname": "灌南县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320800",
                        "ssqname": "淮安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320802",
                                    "ssqname": "清河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320803",
                                    "ssqname": "楚州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320804",
                                    "ssqname": "淮阴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320811",
                                    "ssqname": "清浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320826",
                                    "ssqname": "涟水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320829",
                                    "ssqname": "洪泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320830",
                                    "ssqname": "盱眙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320831",
                                    "ssqname": "金湖县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "320900",
                        "ssqname": "盐城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "320902",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320921",
                                    "ssqname": "响水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320922",
                                    "ssqname": "滨海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320923",
                                    "ssqname": "阜宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320924",
                                    "ssqname": "射阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320925",
                                    "ssqname": "建湖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320928",
                                    "ssqname": "盐都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320981",
                                    "ssqname": "东台市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "320982",
                                    "ssqname": "大丰市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "321000",
                        "ssqname": "扬州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "321002",
                                    "ssqname": "广陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321003",
                                    "ssqname": "邗江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321011",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321023",
                                    "ssqname": "宝应县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321081",
                                    "ssqname": "仪征市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321084",
                                    "ssqname": "高邮市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321088",
                                    "ssqname": "江都市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "321100",
                        "ssqname": "镇江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "321102",
                                    "ssqname": "京口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321111",
                                    "ssqname": "润州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321121",
                                    "ssqname": "丹徒县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321181",
                                    "ssqname": "丹阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321182",
                                    "ssqname": "扬中市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321183",
                                    "ssqname": "句容市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "321200",
                        "ssqname": "泰州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "321202",
                                    "ssqname": "海陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321203",
                                    "ssqname": "高港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321281",
                                    "ssqname": "兴化市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321282",
                                    "ssqname": "靖江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321283",
                                    "ssqname": "泰兴市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321284",
                                    "ssqname": "姜堰市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "321300",
                        "ssqname": "宿迁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "321302",
                                    "ssqname": "宿城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321321",
                                    "ssqname": "宿豫县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321322",
                                    "ssqname": "沭阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321323",
                                    "ssqname": "泗阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "321324",
                                    "ssqname": "泗洪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "330000",
            "ssqname": "浙江省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "330100",
                        "ssqname": "杭州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330102",
                                    "ssqname": "上城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330103",
                                    "ssqname": "下城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330104",
                                    "ssqname": "江干区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330105",
                                    "ssqname": "拱墅区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330106",
                                    "ssqname": "西湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330108",
                                    "ssqname": "滨江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330109",
                                    "ssqname": "萧山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330110",
                                    "ssqname": "余杭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330122",
                                    "ssqname": "桐庐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330127",
                                    "ssqname": "淳安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330182",
                                    "ssqname": "建德市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330183",
                                    "ssqname": "富阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330185",
                                    "ssqname": "临安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330200",
                        "ssqname": "宁波市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330203",
                                    "ssqname": "海曙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330204",
                                    "ssqname": "江东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330205",
                                    "ssqname": "江北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330206",
                                    "ssqname": "北仑区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330211",
                                    "ssqname": "镇海区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330225",
                                    "ssqname": "象山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330226",
                                    "ssqname": "宁海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330227",
                                    "ssqname": "鄞县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330281",
                                    "ssqname": "余姚市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330282",
                                    "ssqname": "慈溪市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330283",
                                    "ssqname": "奉化市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330300",
                        "ssqname": "温州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330302",
                                    "ssqname": "鹿城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330303",
                                    "ssqname": "龙湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330304",
                                    "ssqname": "瓯海区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330322",
                                    "ssqname": "洞头县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330324",
                                    "ssqname": "永嘉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330326",
                                    "ssqname": "平阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330327",
                                    "ssqname": "苍南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330328",
                                    "ssqname": "文成县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330329",
                                    "ssqname": "泰顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330381",
                                    "ssqname": "瑞安市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330382",
                                    "ssqname": "乐清市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330400",
                        "ssqname": "嘉兴市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330402",
                                    "ssqname": "秀城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330411",
                                    "ssqname": "秀洲区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330421",
                                    "ssqname": "嘉善县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330424",
                                    "ssqname": "海盐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330481",
                                    "ssqname": "海宁市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330482",
                                    "ssqname": "平湖市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330483",
                                    "ssqname": "桐乡市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330500",
                        "ssqname": "湖州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330521",
                                    "ssqname": "德清县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330522",
                                    "ssqname": "长兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330523",
                                    "ssqname": "安吉县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330600",
                        "ssqname": "绍兴市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330602",
                                    "ssqname": "越城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330621",
                                    "ssqname": "绍兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330624",
                                    "ssqname": "新昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330681",
                                    "ssqname": "诸暨市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330682",
                                    "ssqname": "上虞市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330683",
                                    "ssqname": "嵊州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330700",
                        "ssqname": "金华市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330702",
                                    "ssqname": "婺城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330703",
                                    "ssqname": "金东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330723",
                                    "ssqname": "武义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330726",
                                    "ssqname": "浦江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330727",
                                    "ssqname": "磐安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330781",
                                    "ssqname": "兰溪市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330782",
                                    "ssqname": "义乌市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330783",
                                    "ssqname": "东阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330784",
                                    "ssqname": "永康市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330800",
                        "ssqname": "衢州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330802",
                                    "ssqname": "柯城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330803",
                                    "ssqname": "衢江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330822",
                                    "ssqname": "常山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330824",
                                    "ssqname": "开化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330825",
                                    "ssqname": "龙游县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330881",
                                    "ssqname": "江山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "330900",
                        "ssqname": "舟山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "330902",
                                    "ssqname": "定海区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330903",
                                    "ssqname": "普陀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330921",
                                    "ssqname": "岱山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "330922",
                                    "ssqname": "嵊泗县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "331000",
                        "ssqname": "台州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "331002",
                                    "ssqname": "椒江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331003",
                                    "ssqname": "黄岩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331004",
                                    "ssqname": "路桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331021",
                                    "ssqname": "玉环县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331022",
                                    "ssqname": "三门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331023",
                                    "ssqname": "天台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331024",
                                    "ssqname": "仙居县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331081",
                                    "ssqname": "温岭市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331082",
                                    "ssqname": "临海市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "331100",
                        "ssqname": "丽水市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "331102",
                                    "ssqname": "莲都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331121",
                                    "ssqname": "青田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331122",
                                    "ssqname": "缙云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331123",
                                    "ssqname": "遂昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331124",
                                    "ssqname": "松阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331125",
                                    "ssqname": "云和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331126",
                                    "ssqname": "庆元县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331127",
                                    "ssqname": "景宁畲族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "331181",
                                    "ssqname": "龙泉市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "340000",
            "ssqname": "安徽省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "340100",
                        "ssqname": "合肥市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340102",
                                    "ssqname": "东市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340103",
                                    "ssqname": "中市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340104",
                                    "ssqname": "西市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340111",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340121",
                                    "ssqname": "长丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340122",
                                    "ssqname": "肥东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340123",
                                    "ssqname": "肥西县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340200",
                        "ssqname": "芜湖市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340202",
                                    "ssqname": "镜湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340203",
                                    "ssqname": "马塘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340204",
                                    "ssqname": "新芜区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340207",
                                    "ssqname": "鸠江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340221",
                                    "ssqname": "芜湖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340222",
                                    "ssqname": "繁昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340223",
                                    "ssqname": "南陵县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340300",
                        "ssqname": "蚌埠市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340302",
                                    "ssqname": "东市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340303",
                                    "ssqname": "中市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340304",
                                    "ssqname": "西市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340311",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340321",
                                    "ssqname": "怀远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340322",
                                    "ssqname": "五河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340323",
                                    "ssqname": "固镇县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340400",
                        "ssqname": "淮南市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340402",
                                    "ssqname": "大通区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340403",
                                    "ssqname": "田家庵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340404",
                                    "ssqname": "谢家集区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340405",
                                    "ssqname": "八公山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340406",
                                    "ssqname": "潘集区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340421",
                                    "ssqname": "凤台县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340500",
                        "ssqname": "马鞍山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340502",
                                    "ssqname": "金家庄区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340503",
                                    "ssqname": "花山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340504",
                                    "ssqname": "雨山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340521",
                                    "ssqname": "当涂县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340600",
                        "ssqname": "淮北市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340602",
                                    "ssqname": "杜集区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340603",
                                    "ssqname": "相山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340604",
                                    "ssqname": "烈山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340621",
                                    "ssqname": "濉溪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340700",
                        "ssqname": "铜陵市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340702",
                                    "ssqname": "铜官山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340703",
                                    "ssqname": "狮子山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340711",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340721",
                                    "ssqname": "铜陵县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "340800",
                        "ssqname": "安庆市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "340802",
                                    "ssqname": "迎江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340803",
                                    "ssqname": "大观区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340811",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340822",
                                    "ssqname": "怀宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340823",
                                    "ssqname": "枞阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340824",
                                    "ssqname": "潜山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340825",
                                    "ssqname": "太湖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340826",
                                    "ssqname": "宿松县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340827",
                                    "ssqname": "望江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340828",
                                    "ssqname": "岳西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "340881",
                                    "ssqname": "桐城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341000",
                        "ssqname": "黄山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341002",
                                    "ssqname": "屯溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341003",
                                    "ssqname": "黄山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341004",
                                    "ssqname": "徽州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341021",
                                    "ssqname": "歙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341022",
                                    "ssqname": "休宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341023",
                                    "ssqname": "黟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341024",
                                    "ssqname": "祁门县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341100",
                        "ssqname": "滁州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341102",
                                    "ssqname": "琅琊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341103",
                                    "ssqname": "南谯区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341122",
                                    "ssqname": "来安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341124",
                                    "ssqname": "全椒县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341125",
                                    "ssqname": "定远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341126",
                                    "ssqname": "凤阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341181",
                                    "ssqname": "天长市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341182",
                                    "ssqname": "明光市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341200",
                        "ssqname": "阜阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341202",
                                    "ssqname": "颍州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341203",
                                    "ssqname": "颍东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341204",
                                    "ssqname": "颍泉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341221",
                                    "ssqname": "临泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341222",
                                    "ssqname": "太和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341225",
                                    "ssqname": "阜南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341226",
                                    "ssqname": "颍上县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341282",
                                    "ssqname": "界首市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341300",
                        "ssqname": "宿州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341302",
                                    "ssqname": "墉桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341321",
                                    "ssqname": "砀山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341322",
                                    "ssqname": "萧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341323",
                                    "ssqname": "灵璧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341324",
                                    "ssqname": "泗县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341400",
                        "ssqname": "巢湖市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341402",
                                    "ssqname": "居巢区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341421",
                                    "ssqname": "庐江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341422",
                                    "ssqname": "无为县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341423",
                                    "ssqname": "含山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341424",
                                    "ssqname": "和县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341500",
                        "ssqname": "六安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341502",
                                    "ssqname": "金安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341503",
                                    "ssqname": "裕安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341521",
                                    "ssqname": "寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341522",
                                    "ssqname": "霍邱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341523",
                                    "ssqname": "舒城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341524",
                                    "ssqname": "金寨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341525",
                                    "ssqname": "霍山县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341600",
                        "ssqname": "亳州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341602",
                                    "ssqname": "谯城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341621",
                                    "ssqname": "涡阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341622",
                                    "ssqname": "蒙城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341623",
                                    "ssqname": "利辛县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341700",
                        "ssqname": "池州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341702",
                                    "ssqname": "贵池区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341721",
                                    "ssqname": "东至县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341722",
                                    "ssqname": "石台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341723",
                                    "ssqname": "青阳县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "341800",
                        "ssqname": "宣城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "341802",
                                    "ssqname": "宣州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341821",
                                    "ssqname": "郎溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341822",
                                    "ssqname": "广德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341823",
                                    "ssqname": "泾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341824",
                                    "ssqname": "绩溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341825",
                                    "ssqname": "旌德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "341881",
                                    "ssqname": "宁国市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "350000",
            "ssqname": "福建省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "350100",
                        "ssqname": "福州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350102",
                                    "ssqname": "鼓楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350103",
                                    "ssqname": "台江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350104",
                                    "ssqname": "仓山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350105",
                                    "ssqname": "马尾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350111",
                                    "ssqname": "晋安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350121",
                                    "ssqname": "闽侯县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350122",
                                    "ssqname": "连江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350123",
                                    "ssqname": "罗源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350124",
                                    "ssqname": "闽清县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350125",
                                    "ssqname": "永泰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350128",
                                    "ssqname": "平潭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350181",
                                    "ssqname": "福清市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350182",
                                    "ssqname": "长乐市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350200",
                        "ssqname": "厦门市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350202",
                                    "ssqname": "鼓浪屿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350203",
                                    "ssqname": "思明区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350204",
                                    "ssqname": "开元区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350205",
                                    "ssqname": "杏林区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350206",
                                    "ssqname": "湖里区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350211",
                                    "ssqname": "集美区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350212",
                                    "ssqname": "同安区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350300",
                        "ssqname": "莆田市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350302",
                                    "ssqname": "城厢区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350303",
                                    "ssqname": "涵江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350321",
                                    "ssqname": "莆田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350322",
                                    "ssqname": "仙游县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350400",
                        "ssqname": "三明市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350402",
                                    "ssqname": "梅列区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350403",
                                    "ssqname": "三元区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350421",
                                    "ssqname": "明溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350423",
                                    "ssqname": "清流县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350424",
                                    "ssqname": "宁化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350425",
                                    "ssqname": "大田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350426",
                                    "ssqname": "尤溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350427",
                                    "ssqname": "沙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350428",
                                    "ssqname": "将乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350429",
                                    "ssqname": "泰宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350430",
                                    "ssqname": "建宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350481",
                                    "ssqname": "永安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350500",
                        "ssqname": "泉州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350502",
                                    "ssqname": "鲤城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350503",
                                    "ssqname": "丰泽区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350504",
                                    "ssqname": "洛江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350505",
                                    "ssqname": "泉港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350521",
                                    "ssqname": "惠安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350524",
                                    "ssqname": "安溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350525",
                                    "ssqname": "永春县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350526",
                                    "ssqname": "德化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350527",
                                    "ssqname": "金门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350581",
                                    "ssqname": "石狮市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350582",
                                    "ssqname": "晋江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350583",
                                    "ssqname": "南安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350600",
                        "ssqname": "漳州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350602",
                                    "ssqname": "芗城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350603",
                                    "ssqname": "龙文区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350622",
                                    "ssqname": "云霄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350623",
                                    "ssqname": "漳浦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350624",
                                    "ssqname": "诏安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350625",
                                    "ssqname": "长泰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350626",
                                    "ssqname": "东山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350627",
                                    "ssqname": "南靖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350628",
                                    "ssqname": "平和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350629",
                                    "ssqname": "华安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350681",
                                    "ssqname": "龙海市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350700",
                        "ssqname": "南平市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350702",
                                    "ssqname": "延平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350721",
                                    "ssqname": "顺昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350722",
                                    "ssqname": "浦城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350723",
                                    "ssqname": "光泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350724",
                                    "ssqname": "松溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350725",
                                    "ssqname": "政和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350781",
                                    "ssqname": "邵武市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350782",
                                    "ssqname": "武夷山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350783",
                                    "ssqname": "建瓯市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350784",
                                    "ssqname": "建阳市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350800",
                        "ssqname": "龙岩市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350802",
                                    "ssqname": "新罗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350821",
                                    "ssqname": "长汀县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350822",
                                    "ssqname": "永定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350823",
                                    "ssqname": "上杭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350824",
                                    "ssqname": "武平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350825",
                                    "ssqname": "连城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350881",
                                    "ssqname": "漳平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "350900",
                        "ssqname": "宁德市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "350902",
                                    "ssqname": "蕉城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350921",
                                    "ssqname": "霞浦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350922",
                                    "ssqname": "古田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350923",
                                    "ssqname": "屏南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350924",
                                    "ssqname": "寿宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350925",
                                    "ssqname": "周宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350926",
                                    "ssqname": "柘荣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350981",
                                    "ssqname": "福安市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "350982",
                                    "ssqname": "福鼎市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "360000",
            "ssqname": "江西省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "360100",
                        "ssqname": "南昌市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360102",
                                    "ssqname": "东湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360103",
                                    "ssqname": "西湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360104",
                                    "ssqname": "青云谱区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360105",
                                    "ssqname": "湾里区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360111",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360121",
                                    "ssqname": "南昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360122",
                                    "ssqname": "新建县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360123",
                                    "ssqname": "安义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360124",
                                    "ssqname": "进贤县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360200",
                        "ssqname": "景德镇市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360202",
                                    "ssqname": "昌江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360203",
                                    "ssqname": "珠山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360222",
                                    "ssqname": "浮梁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360281",
                                    "ssqname": "乐平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360300",
                        "ssqname": "萍乡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360302",
                                    "ssqname": "安源区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360313",
                                    "ssqname": "湘东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360321",
                                    "ssqname": "莲花县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360322",
                                    "ssqname": "上栗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360323",
                                    "ssqname": "芦溪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360400",
                        "ssqname": "九江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360402",
                                    "ssqname": "庐山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360403",
                                    "ssqname": "浔阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360421",
                                    "ssqname": "九江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360423",
                                    "ssqname": "武宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360424",
                                    "ssqname": "修水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360425",
                                    "ssqname": "永修县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360426",
                                    "ssqname": "德安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360427",
                                    "ssqname": "星子县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360428",
                                    "ssqname": "都昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360429",
                                    "ssqname": "湖口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360430",
                                    "ssqname": "彭泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360481",
                                    "ssqname": "瑞昌市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360500",
                        "ssqname": "新余市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360502",
                                    "ssqname": "渝水区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360521",
                                    "ssqname": "分宜县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360600",
                        "ssqname": "鹰潭市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360602",
                                    "ssqname": "月湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360622",
                                    "ssqname": "余江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360681",
                                    "ssqname": "贵溪市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360700",
                        "ssqname": "赣州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360702",
                                    "ssqname": "章贡区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360721",
                                    "ssqname": "赣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360722",
                                    "ssqname": "信丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360723",
                                    "ssqname": "大余县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360724",
                                    "ssqname": "上犹县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360725",
                                    "ssqname": "崇义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360726",
                                    "ssqname": "安远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360727",
                                    "ssqname": "龙南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360728",
                                    "ssqname": "定南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360729",
                                    "ssqname": "全南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360730",
                                    "ssqname": "宁都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360731",
                                    "ssqname": "于都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360732",
                                    "ssqname": "兴国县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360733",
                                    "ssqname": "会昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360734",
                                    "ssqname": "寻乌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360735",
                                    "ssqname": "石城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360781",
                                    "ssqname": "瑞金市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360782",
                                    "ssqname": "南康市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360800",
                        "ssqname": "吉安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360802",
                                    "ssqname": "吉州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360803",
                                    "ssqname": "青原区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360821",
                                    "ssqname": "吉安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360822",
                                    "ssqname": "吉水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360823",
                                    "ssqname": "峡江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360824",
                                    "ssqname": "新干县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360825",
                                    "ssqname": "永丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360826",
                                    "ssqname": "泰和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360827",
                                    "ssqname": "遂川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360828",
                                    "ssqname": "万安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360829",
                                    "ssqname": "安福县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360830",
                                    "ssqname": "永新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360881",
                                    "ssqname": "井冈山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "360900",
                        "ssqname": "宜春市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "360902",
                                    "ssqname": "袁州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360921",
                                    "ssqname": "奉新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360922",
                                    "ssqname": "万载县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360923",
                                    "ssqname": "上高县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360924",
                                    "ssqname": "宜丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360925",
                                    "ssqname": "靖安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360926",
                                    "ssqname": "铜鼓县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360981",
                                    "ssqname": "丰城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360982",
                                    "ssqname": "樟树市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "360983",
                                    "ssqname": "高安市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "361000",
                        "ssqname": "抚州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "361002",
                                    "ssqname": "临川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361021",
                                    "ssqname": "南城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361022",
                                    "ssqname": "黎川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361023",
                                    "ssqname": "南丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361024",
                                    "ssqname": "崇仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361025",
                                    "ssqname": "乐安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361026",
                                    "ssqname": "宜黄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361027",
                                    "ssqname": "金溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361028",
                                    "ssqname": "资溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361029",
                                    "ssqname": "东乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361030",
                                    "ssqname": "广昌县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "361100",
                        "ssqname": "上饶市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "361102",
                                    "ssqname": "信州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361121",
                                    "ssqname": "上饶县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361122",
                                    "ssqname": "广丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361123",
                                    "ssqname": "玉山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361124",
                                    "ssqname": "铅山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361125",
                                    "ssqname": "横峰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361126",
                                    "ssqname": "弋阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361127",
                                    "ssqname": "余干县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361128",
                                    "ssqname": "波阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361129",
                                    "ssqname": "万年县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361130",
                                    "ssqname": "婺源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "361181",
                                    "ssqname": "德兴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "370000",
            "ssqname": "山东省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "370100",
                        "ssqname": "济南市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370102",
                                    "ssqname": "历下区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370103",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370104",
                                    "ssqname": "槐荫区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370105",
                                    "ssqname": "天桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370112",
                                    "ssqname": "历城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370113",
                                    "ssqname": "长清区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370124",
                                    "ssqname": "平阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370125",
                                    "ssqname": "济阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370126",
                                    "ssqname": "商河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370181",
                                    "ssqname": "章丘市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370200",
                        "ssqname": "青岛市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370202",
                                    "ssqname": "市南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370203",
                                    "ssqname": "市北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370205",
                                    "ssqname": "四方区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370211",
                                    "ssqname": "黄岛区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370212",
                                    "ssqname": "崂山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370213",
                                    "ssqname": "李沧区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370214",
                                    "ssqname": "城阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370281",
                                    "ssqname": "胶州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370282",
                                    "ssqname": "即墨市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370283",
                                    "ssqname": "平度市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370284",
                                    "ssqname": "胶南市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370285",
                                    "ssqname": "莱西市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370300",
                        "ssqname": "淄博市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370302",
                                    "ssqname": "淄川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370303",
                                    "ssqname": "张店区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370304",
                                    "ssqname": "博山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370305",
                                    "ssqname": "临淄区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370306",
                                    "ssqname": "周村区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370321",
                                    "ssqname": "桓台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370322",
                                    "ssqname": "高青县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370323",
                                    "ssqname": "沂源县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370400",
                        "ssqname": "枣庄市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370402",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370403",
                                    "ssqname": "薛城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370404",
                                    "ssqname": "峄城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370405",
                                    "ssqname": "台儿庄区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370406",
                                    "ssqname": "山亭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370481",
                                    "ssqname": "滕州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370500",
                        "ssqname": "东营市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370502",
                                    "ssqname": "东营区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370503",
                                    "ssqname": "河口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370521",
                                    "ssqname": "垦利县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370522",
                                    "ssqname": "利津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370523",
                                    "ssqname": "广饶县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370600",
                        "ssqname": "烟台市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370602",
                                    "ssqname": "芝罘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370611",
                                    "ssqname": "福山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370612",
                                    "ssqname": "牟平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370613",
                                    "ssqname": "莱山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370634",
                                    "ssqname": "长岛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370681",
                                    "ssqname": "龙口市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370682",
                                    "ssqname": "莱阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370683",
                                    "ssqname": "莱州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370684",
                                    "ssqname": "蓬莱市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370685",
                                    "ssqname": "招远市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370686",
                                    "ssqname": "栖霞市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370687",
                                    "ssqname": "海阳市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370700",
                        "ssqname": "潍坊市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370702",
                                    "ssqname": "潍城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370703",
                                    "ssqname": "寒亭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370704",
                                    "ssqname": "坊子区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370705",
                                    "ssqname": "奎文区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370724",
                                    "ssqname": "临朐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370725",
                                    "ssqname": "昌乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370781",
                                    "ssqname": "青州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370782",
                                    "ssqname": "诸城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370783",
                                    "ssqname": "寿光市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370784",
                                    "ssqname": "安丘市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370785",
                                    "ssqname": "高密市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370786",
                                    "ssqname": "昌邑市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370800",
                        "ssqname": "济宁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370802",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370811",
                                    "ssqname": "任城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370826",
                                    "ssqname": "微山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370827",
                                    "ssqname": "鱼台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370828",
                                    "ssqname": "金乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370829",
                                    "ssqname": "嘉祥县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370830",
                                    "ssqname": "汶上县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370831",
                                    "ssqname": "泗水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370832",
                                    "ssqname": "梁山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370881",
                                    "ssqname": "曲阜市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370882",
                                    "ssqname": "兖州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370883",
                                    "ssqname": "邹城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "370900",
                        "ssqname": "泰安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "370902",
                                    "ssqname": "泰山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370903",
                                    "ssqname": "岱岳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370921",
                                    "ssqname": "宁阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370923",
                                    "ssqname": "东平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370982",
                                    "ssqname": "新泰市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "370983",
                                    "ssqname": "肥城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371000",
                        "ssqname": "威海市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371002",
                                    "ssqname": "环翠区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371081",
                                    "ssqname": "文登市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371082",
                                    "ssqname": "荣成市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371083",
                                    "ssqname": "乳山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371100",
                        "ssqname": "日照市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371102",
                                    "ssqname": "东港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371121",
                                    "ssqname": "五莲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371122",
                                    "ssqname": "莒县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371200",
                        "ssqname": "莱芜市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371202",
                                    "ssqname": "莱城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371203",
                                    "ssqname": "钢城区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371300",
                        "ssqname": "临沂市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371302",
                                    "ssqname": "兰山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371311",
                                    "ssqname": "罗庄区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371312",
                                    "ssqname": "河东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371321",
                                    "ssqname": "沂南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371322",
                                    "ssqname": "郯城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371323",
                                    "ssqname": "沂水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371324",
                                    "ssqname": "苍山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371325",
                                    "ssqname": "费县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371326",
                                    "ssqname": "平邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371327",
                                    "ssqname": "莒南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371328",
                                    "ssqname": "蒙阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371329",
                                    "ssqname": "临沭县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371400",
                        "ssqname": "德州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371402",
                                    "ssqname": "德城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371421",
                                    "ssqname": "陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371422",
                                    "ssqname": "宁津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371423",
                                    "ssqname": "庆云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371424",
                                    "ssqname": "临邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371425",
                                    "ssqname": "齐河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371426",
                                    "ssqname": "平原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371427",
                                    "ssqname": "夏津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371428",
                                    "ssqname": "武城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371481",
                                    "ssqname": "乐陵市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371482",
                                    "ssqname": "禹城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371500",
                        "ssqname": "聊城市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371502",
                                    "ssqname": "东昌府区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371521",
                                    "ssqname": "阳谷县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371522",
                                    "ssqname": "莘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371523",
                                    "ssqname": "茌平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371524",
                                    "ssqname": "东阿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371525",
                                    "ssqname": "冠县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371526",
                                    "ssqname": "高唐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371581",
                                    "ssqname": "临清市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371600",
                        "ssqname": "滨州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371602",
                                    "ssqname": "滨城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371621",
                                    "ssqname": "惠民县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371622",
                                    "ssqname": "阳信县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371623",
                                    "ssqname": "无棣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371624",
                                    "ssqname": "沾化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371625",
                                    "ssqname": "博兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371626",
                                    "ssqname": "邹平县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "371700",
                        "ssqname": "荷泽市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "371702",
                                    "ssqname": "牡丹区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371721",
                                    "ssqname": "曹县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371722",
                                    "ssqname": "单县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371723",
                                    "ssqname": "成武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371724",
                                    "ssqname": "巨野县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371725",
                                    "ssqname": "郓城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371726",
                                    "ssqname": "鄄城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371727",
                                    "ssqname": "定陶县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "371728",
                                    "ssqname": "东明县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "410000",
            "ssqname": "河南省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "410100",
                        "ssqname": "郑州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410102",
                                    "ssqname": "中原区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410103",
                                    "ssqname": "二七区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410104",
                                    "ssqname": "管城回族区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410105",
                                    "ssqname": "金水区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410106",
                                    "ssqname": "上街区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410108",
                                    "ssqname": "邙山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410122",
                                    "ssqname": "中牟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410181",
                                    "ssqname": "巩义市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410182",
                                    "ssqname": "荥阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410183",
                                    "ssqname": "新密市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410184",
                                    "ssqname": "新郑市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410185",
                                    "ssqname": "登封市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410200",
                        "ssqname": "开封市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410202",
                                    "ssqname": "龙亭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410203",
                                    "ssqname": "顺河回族区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410204",
                                    "ssqname": "鼓楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410205",
                                    "ssqname": "南关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410211",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410221",
                                    "ssqname": "杞县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410222",
                                    "ssqname": "通许县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410223",
                                    "ssqname": "尉氏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410224",
                                    "ssqname": "开封县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410225",
                                    "ssqname": "兰考县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410300",
                        "ssqname": "洛阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410302",
                                    "ssqname": "老城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410303",
                                    "ssqname": "西工区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410304",
                                    "ssqname": "廛河回族区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410305",
                                    "ssqname": "涧西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410306",
                                    "ssqname": "吉利区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410307",
                                    "ssqname": "洛龙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410322",
                                    "ssqname": "孟津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410323",
                                    "ssqname": "新安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410324",
                                    "ssqname": "栾川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410325",
                                    "ssqname": "嵩县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410326",
                                    "ssqname": "汝阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410327",
                                    "ssqname": "宜阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410328",
                                    "ssqname": "洛宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410329",
                                    "ssqname": "伊川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410381",
                                    "ssqname": "偃师市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410400",
                        "ssqname": "平顶山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410402",
                                    "ssqname": "新华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410403",
                                    "ssqname": "卫东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410404",
                                    "ssqname": "石龙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410411",
                                    "ssqname": "湛河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410421",
                                    "ssqname": "宝丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410422",
                                    "ssqname": "叶县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410423",
                                    "ssqname": "鲁山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410425",
                                    "ssqname": "郏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410481",
                                    "ssqname": "舞钢市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410482",
                                    "ssqname": "汝州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410500",
                        "ssqname": "安阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410502",
                                    "ssqname": "文峰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410503",
                                    "ssqname": "北关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410504",
                                    "ssqname": "铁西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410511",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410522",
                                    "ssqname": "安阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410523",
                                    "ssqname": "汤阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410526",
                                    "ssqname": "滑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410527",
                                    "ssqname": "内黄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410581",
                                    "ssqname": "林州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410600",
                        "ssqname": "鹤壁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410602",
                                    "ssqname": "鹤山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410603",
                                    "ssqname": "山城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410611",
                                    "ssqname": "淇滨区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410621",
                                    "ssqname": "浚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410622",
                                    "ssqname": "淇县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410700",
                        "ssqname": "新乡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410702",
                                    "ssqname": "红旗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410703",
                                    "ssqname": "新华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410704",
                                    "ssqname": "北站区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410711",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410721",
                                    "ssqname": "新乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410724",
                                    "ssqname": "获嘉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410725",
                                    "ssqname": "原阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410726",
                                    "ssqname": "延津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410727",
                                    "ssqname": "封丘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410728",
                                    "ssqname": "长垣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410781",
                                    "ssqname": "卫辉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410782",
                                    "ssqname": "辉县市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410800",
                        "ssqname": "焦作市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410802",
                                    "ssqname": "解放区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410803",
                                    "ssqname": "中站区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410804",
                                    "ssqname": "马村区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410811",
                                    "ssqname": "山阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410821",
                                    "ssqname": "修武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410822",
                                    "ssqname": "博爱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410823",
                                    "ssqname": "武陟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410825",
                                    "ssqname": "温县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410881",
                                    "ssqname": "济源市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410882",
                                    "ssqname": "沁阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410883",
                                    "ssqname": "孟州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "410900",
                        "ssqname": "濮阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "410902",
                                    "ssqname": "市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410922",
                                    "ssqname": "清丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410923",
                                    "ssqname": "南乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410926",
                                    "ssqname": "范县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410927",
                                    "ssqname": "台前县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "410928",
                                    "ssqname": "濮阳县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411000",
                        "ssqname": "许昌市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411002",
                                    "ssqname": "魏都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411023",
                                    "ssqname": "许昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411024",
                                    "ssqname": "鄢陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411025",
                                    "ssqname": "襄城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411081",
                                    "ssqname": "禹州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411082",
                                    "ssqname": "长葛市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411100",
                        "ssqname": "漯河市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411102",
                                    "ssqname": "源汇区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411121",
                                    "ssqname": "舞阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411122",
                                    "ssqname": "临颍县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411123",
                                    "ssqname": "郾城县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411200",
                        "ssqname": "三门峡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411202",
                                    "ssqname": "湖滨区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411221",
                                    "ssqname": "渑池县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411222",
                                    "ssqname": "陕县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411224",
                                    "ssqname": "卢氏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411281",
                                    "ssqname": "义马市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411282",
                                    "ssqname": "灵宝市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411300",
                        "ssqname": "南阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411302",
                                    "ssqname": "宛城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411303",
                                    "ssqname": "卧龙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411321",
                                    "ssqname": "南召县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411322",
                                    "ssqname": "方城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411323",
                                    "ssqname": "西峡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411324",
                                    "ssqname": "镇平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411325",
                                    "ssqname": "内乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411326",
                                    "ssqname": "淅川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411327",
                                    "ssqname": "社旗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411328",
                                    "ssqname": "唐河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411329",
                                    "ssqname": "新野县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411330",
                                    "ssqname": "桐柏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411381",
                                    "ssqname": "邓州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411400",
                        "ssqname": "商丘市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411402",
                                    "ssqname": "梁园区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411403",
                                    "ssqname": "睢阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411421",
                                    "ssqname": "民权县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411422",
                                    "ssqname": "睢县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411423",
                                    "ssqname": "宁陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411424",
                                    "ssqname": "柘城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411425",
                                    "ssqname": "虞城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411426",
                                    "ssqname": "夏邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411481",
                                    "ssqname": "永城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411500",
                        "ssqname": "信阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411502",
                                    "ssqname": "师河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411503",
                                    "ssqname": "平桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411521",
                                    "ssqname": "罗山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411522",
                                    "ssqname": "光山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411523",
                                    "ssqname": "新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411524",
                                    "ssqname": "商城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411525",
                                    "ssqname": "固始县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411526",
                                    "ssqname": "潢川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411527",
                                    "ssqname": "淮滨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411528",
                                    "ssqname": "息县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411600",
                        "ssqname": "周口市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411602",
                                    "ssqname": "川汇区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411621",
                                    "ssqname": "扶沟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411622",
                                    "ssqname": "西华县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411623",
                                    "ssqname": "商水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411624",
                                    "ssqname": "沈丘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411625",
                                    "ssqname": "郸城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411626",
                                    "ssqname": "淮阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411627",
                                    "ssqname": "太康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411628",
                                    "ssqname": "鹿邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411681",
                                    "ssqname": "项城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "411700",
                        "ssqname": "驻马店市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "411702",
                                    "ssqname": "驿城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411721",
                                    "ssqname": "西平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411722",
                                    "ssqname": "上蔡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411723",
                                    "ssqname": "平舆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411724",
                                    "ssqname": "正阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411725",
                                    "ssqname": "确山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411726",
                                    "ssqname": "泌阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411727",
                                    "ssqname": "汝南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411728",
                                    "ssqname": "遂平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "411729",
                                    "ssqname": "新蔡县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "420000",
            "ssqname": "湖北省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "420100",
                        "ssqname": "武汉市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420102",
                                    "ssqname": "江岸区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420103",
                                    "ssqname": "江汉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420104",
                                    "ssqname": "乔口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420105",
                                    "ssqname": "汉阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420106",
                                    "ssqname": "武昌区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420107",
                                    "ssqname": "青山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420111",
                                    "ssqname": "洪山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420112",
                                    "ssqname": "东西湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420113",
                                    "ssqname": "汉南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420114",
                                    "ssqname": "蔡甸区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420115",
                                    "ssqname": "江夏区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420116",
                                    "ssqname": "黄陂区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420117",
                                    "ssqname": "新洲区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420200",
                        "ssqname": "黄石市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420202",
                                    "ssqname": "黄石港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420203",
                                    "ssqname": "西塞山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420204",
                                    "ssqname": "下陆区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420205",
                                    "ssqname": "铁山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420222",
                                    "ssqname": "阳新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420281",
                                    "ssqname": "大冶市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420300",
                        "ssqname": "十堰市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420302",
                                    "ssqname": "茅箭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420303",
                                    "ssqname": "张湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420321",
                                    "ssqname": "郧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420322",
                                    "ssqname": "郧西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420323",
                                    "ssqname": "竹山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420324",
                                    "ssqname": "竹溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420325",
                                    "ssqname": "房县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420381",
                                    "ssqname": "丹江口市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420500",
                        "ssqname": "宜昌市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420502",
                                    "ssqname": "西陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420503",
                                    "ssqname": "伍家岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420504",
                                    "ssqname": "点军区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420505",
                                    "ssqname": "虎亭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420506",
                                    "ssqname": "夷陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420525",
                                    "ssqname": "远安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420526",
                                    "ssqname": "兴山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420527",
                                    "ssqname": "秭归县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420528",
                                    "ssqname": "长阳土家族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420529",
                                    "ssqname": "五峰土家族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420581",
                                    "ssqname": "宜都市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420582",
                                    "ssqname": "当阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420583",
                                    "ssqname": "枝江市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420600",
                        "ssqname": "襄樊市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420602",
                                    "ssqname": "襄城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420606",
                                    "ssqname": "樊城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420607",
                                    "ssqname": "襄阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420624",
                                    "ssqname": "南漳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420625",
                                    "ssqname": "谷城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420626",
                                    "ssqname": "保康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420682",
                                    "ssqname": "老河口市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420683",
                                    "ssqname": "枣阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420684",
                                    "ssqname": "宜城市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420700",
                        "ssqname": "鄂州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420702",
                                    "ssqname": "梁子湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420703",
                                    "ssqname": "华容区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420704",
                                    "ssqname": "鄂城区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420800",
                        "ssqname": "荆门市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420802",
                                    "ssqname": "东宝区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420804",
                                    "ssqname": "掇刀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420821",
                                    "ssqname": "京山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420822",
                                    "ssqname": "沙洋县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420881",
                                    "ssqname": "钟祥市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "420900",
                        "ssqname": "孝感市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "420902",
                                    "ssqname": "孝南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420921",
                                    "ssqname": "孝昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420922",
                                    "ssqname": "大悟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420923",
                                    "ssqname": "云梦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420981",
                                    "ssqname": "应城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420982",
                                    "ssqname": "安陆市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "420984",
                                    "ssqname": "汉川市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "421000",
                        "ssqname": "荆州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "421002",
                                    "ssqname": "沙市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421003",
                                    "ssqname": "荆州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421022",
                                    "ssqname": "公安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421023",
                                    "ssqname": "监利县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421024",
                                    "ssqname": "江陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421081",
                                    "ssqname": "石首市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421083",
                                    "ssqname": "洪湖市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421087",
                                    "ssqname": "松滋市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "421100",
                        "ssqname": "黄冈市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "421102",
                                    "ssqname": "黄州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421121",
                                    "ssqname": "团风县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421122",
                                    "ssqname": "红安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421123",
                                    "ssqname": "罗田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421124",
                                    "ssqname": "英山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421125",
                                    "ssqname": "浠水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421126",
                                    "ssqname": "蕲春县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421127",
                                    "ssqname": "黄梅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421181",
                                    "ssqname": "麻城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421182",
                                    "ssqname": "武穴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "421200",
                        "ssqname": "咸宁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "421202",
                                    "ssqname": "咸安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421221",
                                    "ssqname": "嘉鱼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421222",
                                    "ssqname": "通城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421223",
                                    "ssqname": "崇阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421224",
                                    "ssqname": "通山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421281",
                                    "ssqname": "赤壁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "421300",
                        "ssqname": "随州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "421302",
                                    "ssqname": "曾都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "421381",
                                    "ssqname": "广水市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "422800",
                        "ssqname": "恩施土家族苗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "422801",
                                    "ssqname": "恩施市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422802",
                                    "ssqname": "利川市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422822",
                                    "ssqname": "建始县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422823",
                                    "ssqname": "巴东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422825",
                                    "ssqname": "宣恩县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422826",
                                    "ssqname": "咸丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422827",
                                    "ssqname": "来凤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "422828",
                                    "ssqname": "鹤峰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "429000",
                        "ssqname": "县级市区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "429004",
                                    "ssqname": "仙桃市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "429005",
                                    "ssqname": "潜江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "429006",
                                    "ssqname": "天门市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "429021",
                                    "ssqname": "神农架林区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "430000",
            "ssqname": "湖南省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "430100",
                        "ssqname": "长沙市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430102",
                                    "ssqname": "芙蓉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430103",
                                    "ssqname": "天心区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430104",
                                    "ssqname": "岳麓区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430105",
                                    "ssqname": "开福区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430111",
                                    "ssqname": "雨花区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430121",
                                    "ssqname": "长沙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430122",
                                    "ssqname": "望城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430124",
                                    "ssqname": "宁乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430181",
                                    "ssqname": "浏阳市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430200",
                        "ssqname": "株洲市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430202",
                                    "ssqname": "荷塘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430203",
                                    "ssqname": "芦淞区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430204",
                                    "ssqname": "石峰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430211",
                                    "ssqname": "天元区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430221",
                                    "ssqname": "株洲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430223",
                                    "ssqname": "攸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430224",
                                    "ssqname": "茶陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430225",
                                    "ssqname": "炎陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430281",
                                    "ssqname": "醴陵市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430300",
                        "ssqname": "湘潭市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430302",
                                    "ssqname": "雨湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430304",
                                    "ssqname": "岳塘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430321",
                                    "ssqname": "湘潭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430381",
                                    "ssqname": "湘乡市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430382",
                                    "ssqname": "韶山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430400",
                        "ssqname": "衡阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430405",
                                    "ssqname": "珠晖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430406",
                                    "ssqname": "雁峰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430407",
                                    "ssqname": "石鼓区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430408",
                                    "ssqname": "蒸湘区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430412",
                                    "ssqname": "南岳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430421",
                                    "ssqname": "衡阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430422",
                                    "ssqname": "衡南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430423",
                                    "ssqname": "衡山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430424",
                                    "ssqname": "衡东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430426",
                                    "ssqname": "祁东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430481",
                                    "ssqname": "耒阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430482",
                                    "ssqname": "常宁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430500",
                        "ssqname": "邵阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430502",
                                    "ssqname": "双清区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430503",
                                    "ssqname": "大祥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430511",
                                    "ssqname": "北塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430521",
                                    "ssqname": "邵东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430522",
                                    "ssqname": "新邵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430523",
                                    "ssqname": "邵阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430524",
                                    "ssqname": "隆回县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430525",
                                    "ssqname": "洞口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430527",
                                    "ssqname": "绥宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430528",
                                    "ssqname": "新宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430529",
                                    "ssqname": "城步苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430581",
                                    "ssqname": "武冈市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430600",
                        "ssqname": "岳阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430602",
                                    "ssqname": "岳阳楼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430603",
                                    "ssqname": "云溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430611",
                                    "ssqname": "君山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430621",
                                    "ssqname": "岳阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430623",
                                    "ssqname": "华容县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430624",
                                    "ssqname": "湘阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430626",
                                    "ssqname": "平江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430681",
                                    "ssqname": "汨罗市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430682",
                                    "ssqname": "临湘市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430700",
                        "ssqname": "常德市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430702",
                                    "ssqname": "武陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430703",
                                    "ssqname": "鼎城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430721",
                                    "ssqname": "安乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430722",
                                    "ssqname": "汉寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430723",
                                    "ssqname": "澧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430724",
                                    "ssqname": "临澧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430725",
                                    "ssqname": "桃源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430726",
                                    "ssqname": "石门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430781",
                                    "ssqname": "津市市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430800",
                        "ssqname": "张家界市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430802",
                                    "ssqname": "永定区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430811",
                                    "ssqname": "武陵源区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430821",
                                    "ssqname": "慈利县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430822",
                                    "ssqname": "桑植县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "430900",
                        "ssqname": "益阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "430902",
                                    "ssqname": "资阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430903",
                                    "ssqname": "赫山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430921",
                                    "ssqname": "南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430922",
                                    "ssqname": "桃江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430923",
                                    "ssqname": "安化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "430981",
                                    "ssqname": "沅江市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "431000",
                        "ssqname": "郴州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "431002",
                                    "ssqname": "北湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431003",
                                    "ssqname": "苏仙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431021",
                                    "ssqname": "桂阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431022",
                                    "ssqname": "宜章县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431023",
                                    "ssqname": "永兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431024",
                                    "ssqname": "嘉禾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431025",
                                    "ssqname": "临武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431026",
                                    "ssqname": "汝城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431027",
                                    "ssqname": "桂东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431028",
                                    "ssqname": "安仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431081",
                                    "ssqname": "资兴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "431100",
                        "ssqname": "永州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "431102",
                                    "ssqname": "芝山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431103",
                                    "ssqname": "冷水滩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431121",
                                    "ssqname": "祁阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431122",
                                    "ssqname": "东安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431123",
                                    "ssqname": "双牌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431124",
                                    "ssqname": "道县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431125",
                                    "ssqname": "江永县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431126",
                                    "ssqname": "宁远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431127",
                                    "ssqname": "蓝山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431128",
                                    "ssqname": "新田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431129",
                                    "ssqname": "江华瑶族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "431200",
                        "ssqname": "怀化市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "431202",
                                    "ssqname": "鹤城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431221",
                                    "ssqname": "中方县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431222",
                                    "ssqname": "沅陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431223",
                                    "ssqname": "辰溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431224",
                                    "ssqname": "溆浦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431225",
                                    "ssqname": "会同县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431226",
                                    "ssqname": "麻阳苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431227",
                                    "ssqname": "新晃侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431228",
                                    "ssqname": "芷江侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431229",
                                    "ssqname": "靖州苗族侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431230",
                                    "ssqname": "通道侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431281",
                                    "ssqname": "洪江市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "431300",
                        "ssqname": "娄底市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "431302",
                                    "ssqname": "娄星区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431321",
                                    "ssqname": "双峰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431322",
                                    "ssqname": "新化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431381",
                                    "ssqname": "冷水江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "431382",
                                    "ssqname": "涟源市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "433100",
                        "ssqname": "湘西土家族苗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "433101",
                                    "ssqname": "吉首市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433122",
                                    "ssqname": "泸溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433123",
                                    "ssqname": "凤凰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433124",
                                    "ssqname": "花垣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433125",
                                    "ssqname": "保靖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433126",
                                    "ssqname": "古丈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433127",
                                    "ssqname": "永顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "433130",
                                    "ssqname": "龙山县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "440000",
            "ssqname": "广东省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "440100",
                        "ssqname": "广州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440102",
                                    "ssqname": "东山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440103",
                                    "ssqname": "荔湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440104",
                                    "ssqname": "越秀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440105",
                                    "ssqname": "海珠区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440106",
                                    "ssqname": "天河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440107",
                                    "ssqname": "芳村区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440111",
                                    "ssqname": "白云区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440112",
                                    "ssqname": "黄埔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440113",
                                    "ssqname": "番禺区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440114",
                                    "ssqname": "花都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440183",
                                    "ssqname": "增城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440184",
                                    "ssqname": "从化市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440200",
                        "ssqname": "韶关市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440202",
                                    "ssqname": "北江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440203",
                                    "ssqname": "武江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440204",
                                    "ssqname": "浈江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440221",
                                    "ssqname": "曲江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440222",
                                    "ssqname": "始兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440224",
                                    "ssqname": "仁化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440229",
                                    "ssqname": "翁源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440232",
                                    "ssqname": "乳源瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440233",
                                    "ssqname": "新丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440281",
                                    "ssqname": "乐昌市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440282",
                                    "ssqname": "南雄市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440300",
                        "ssqname": "深圳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440303",
                                    "ssqname": "罗湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440304",
                                    "ssqname": "福田区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440305",
                                    "ssqname": "南山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440306",
                                    "ssqname": "宝安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440307",
                                    "ssqname": "龙岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440308",
                                    "ssqname": "盐田区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440400",
                        "ssqname": "珠海市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440402",
                                    "ssqname": "香洲区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440403",
                                    "ssqname": "斗门区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440404",
                                    "ssqname": "金湾区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440500",
                        "ssqname": "汕头市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440506",
                                    "ssqname": "达濠区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440507",
                                    "ssqname": "龙湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440508",
                                    "ssqname": "金园区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440509",
                                    "ssqname": "升平区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440510",
                                    "ssqname": "河浦区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440523",
                                    "ssqname": "南澳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440582",
                                    "ssqname": "潮阳市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440583",
                                    "ssqname": "澄海市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440600",
                        "ssqname": "佛山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440602",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440603",
                                    "ssqname": "石湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440681",
                                    "ssqname": "顺德市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440682",
                                    "ssqname": "南海市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440683",
                                    "ssqname": "三水市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440684",
                                    "ssqname": "高明市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440700",
                        "ssqname": "江门市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440703",
                                    "ssqname": "蓬江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440704",
                                    "ssqname": "江海区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440781",
                                    "ssqname": "台山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440782",
                                    "ssqname": "新会市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440783",
                                    "ssqname": "开平市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440784",
                                    "ssqname": "鹤山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440785",
                                    "ssqname": "恩平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440800",
                        "ssqname": "湛江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440802",
                                    "ssqname": "赤坎区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440803",
                                    "ssqname": "霞山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440804",
                                    "ssqname": "坡头区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440811",
                                    "ssqname": "麻章区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440823",
                                    "ssqname": "遂溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440825",
                                    "ssqname": "徐闻县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440881",
                                    "ssqname": "廉江市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440882",
                                    "ssqname": "雷州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440883",
                                    "ssqname": "吴川市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "440900",
                        "ssqname": "茂名市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "440902",
                                    "ssqname": "茂南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440903",
                                    "ssqname": "茂港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440923",
                                    "ssqname": "电白县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440981",
                                    "ssqname": "高州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440982",
                                    "ssqname": "化州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "440983",
                                    "ssqname": "信宜市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441200",
                        "ssqname": "肇庆市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441202",
                                    "ssqname": "端州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441203",
                                    "ssqname": "鼎湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441223",
                                    "ssqname": "广宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441224",
                                    "ssqname": "怀集县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441225",
                                    "ssqname": "封开县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441226",
                                    "ssqname": "德庆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441283",
                                    "ssqname": "高要市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441284",
                                    "ssqname": "四会市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441300",
                        "ssqname": "惠州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441302",
                                    "ssqname": "惠城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441322",
                                    "ssqname": "博罗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441323",
                                    "ssqname": "惠东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441324",
                                    "ssqname": "龙门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441381",
                                    "ssqname": "惠阳市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441400",
                        "ssqname": "梅州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441402",
                                    "ssqname": "梅江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441421",
                                    "ssqname": "梅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441422",
                                    "ssqname": "大埔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441423",
                                    "ssqname": "丰顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441424",
                                    "ssqname": "五华县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441426",
                                    "ssqname": "平远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441427",
                                    "ssqname": "蕉岭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441481",
                                    "ssqname": "兴宁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441500",
                        "ssqname": "汕尾市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441502",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441521",
                                    "ssqname": "海丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441523",
                                    "ssqname": "陆河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441581",
                                    "ssqname": "陆丰市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441600",
                        "ssqname": "河源市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441602",
                                    "ssqname": "源城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441621",
                                    "ssqname": "紫金县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441622",
                                    "ssqname": "龙川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441623",
                                    "ssqname": "连平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441624",
                                    "ssqname": "和平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441625",
                                    "ssqname": "东源县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441700",
                        "ssqname": "阳江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441702",
                                    "ssqname": "江城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441721",
                                    "ssqname": "阳西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441723",
                                    "ssqname": "阳东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441781",
                                    "ssqname": "阳春市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441800",
                        "ssqname": "清远市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "441802",
                                    "ssqname": "清城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441821",
                                    "ssqname": "佛冈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441823",
                                    "ssqname": "阳山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441825",
                                    "ssqname": "连山壮族瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441826",
                                    "ssqname": "连南瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441827",
                                    "ssqname": "清新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441881",
                                    "ssqname": "英德市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "441882",
                                    "ssqname": "连州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "441900",
                        "ssqname": "东莞市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "441901",
                                "ssqname": "东莞市",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "442000",
                        "ssqname": "中山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "442001",
                                "ssqname": "中山市",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "445100",
                        "ssqname": "潮州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "445102",
                                    "ssqname": "湘桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445121",
                                    "ssqname": "潮安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445122",
                                    "ssqname": "饶平县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "445200",
                        "ssqname": "揭阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "445202",
                                    "ssqname": "榕城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445221",
                                    "ssqname": "揭东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445222",
                                    "ssqname": "揭西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445224",
                                    "ssqname": "惠来县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445281",
                                    "ssqname": "普宁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "445300",
                        "ssqname": "云浮市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "445302",
                                    "ssqname": "云城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445321",
                                    "ssqname": "新兴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445322",
                                    "ssqname": "郁南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445323",
                                    "ssqname": "云安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "445381",
                                    "ssqname": "罗定市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "450000",
            "ssqname": "广西省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "450100",
                        "ssqname": "南宁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450102",
                                    "ssqname": "兴宁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450103",
                                    "ssqname": "新城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450104",
                                    "ssqname": "城北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450105",
                                    "ssqname": "江南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450106",
                                    "ssqname": "永新区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450121",
                                    "ssqname": "邕宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450122",
                                    "ssqname": "武鸣县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450200",
                        "ssqname": "柳州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450202",
                                    "ssqname": "城中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450203",
                                    "ssqname": "鱼峰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450204",
                                    "ssqname": "柳南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450205",
                                    "ssqname": "柳北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450211",
                                    "ssqname": "市郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450221",
                                    "ssqname": "柳江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450222",
                                    "ssqname": "柳城县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450300",
                        "ssqname": "桂林市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450302",
                                    "ssqname": "秀峰区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450303",
                                    "ssqname": "叠彩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450304",
                                    "ssqname": "象山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450305",
                                    "ssqname": "七星区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450311",
                                    "ssqname": "雁山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450321",
                                    "ssqname": "阳朔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450322",
                                    "ssqname": "临桂县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450323",
                                    "ssqname": "灵川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450324",
                                    "ssqname": "全州县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450325",
                                    "ssqname": "兴安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450326",
                                    "ssqname": "永福县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450327",
                                    "ssqname": "灌阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450328",
                                    "ssqname": "龙胜各族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450329",
                                    "ssqname": "资源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450330",
                                    "ssqname": "平乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450331",
                                    "ssqname": "荔蒲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450332",
                                    "ssqname": "恭城瑶族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450400",
                        "ssqname": "梧州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450403",
                                    "ssqname": "万秀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450404",
                                    "ssqname": "蝶山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450411",
                                    "ssqname": "市郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450421",
                                    "ssqname": "苍梧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450422",
                                    "ssqname": "藤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450423",
                                    "ssqname": "蒙山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450481",
                                    "ssqname": "岑溪市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450500",
                        "ssqname": "北海市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450502",
                                    "ssqname": "海城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450503",
                                    "ssqname": "银海区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450512",
                                    "ssqname": "铁山港区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450521",
                                    "ssqname": "合浦县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450600",
                        "ssqname": "防城港市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450602",
                                    "ssqname": "港口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450603",
                                    "ssqname": "防城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450621",
                                    "ssqname": "上思县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450681",
                                    "ssqname": "东兴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450700",
                        "ssqname": "钦州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450702",
                                    "ssqname": "钦南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450703",
                                    "ssqname": "钦北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450721",
                                    "ssqname": "浦北县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450722",
                                    "ssqname": "灵山县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450800",
                        "ssqname": "贵港市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450802",
                                    "ssqname": "港北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450803",
                                    "ssqname": "港南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450821",
                                    "ssqname": "平南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450881",
                                    "ssqname": "桂平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "450900",
                        "ssqname": "玉林市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "450902",
                                    "ssqname": "玉州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450921",
                                    "ssqname": "容县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450922",
                                    "ssqname": "陆川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450923",
                                    "ssqname": "博白县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450924",
                                    "ssqname": "兴业县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "450981",
                                    "ssqname": "北流市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "452100",
                        "ssqname": "南宁地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "452101",
                                    "ssqname": "凭祥市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452122",
                                    "ssqname": "横县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452123",
                                    "ssqname": "宾阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452124",
                                    "ssqname": "上林县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452126",
                                    "ssqname": "隆安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452127",
                                    "ssqname": "马山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452128",
                                    "ssqname": "扶绥县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452129",
                                    "ssqname": "崇左县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452130",
                                    "ssqname": "大新县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452131",
                                    "ssqname": "天等县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452132",
                                    "ssqname": "宁明县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452133",
                                    "ssqname": "龙州县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "452200",
                        "ssqname": "柳州地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "452201",
                                    "ssqname": "合山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452223",
                                    "ssqname": "鹿寨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452224",
                                    "ssqname": "象州县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452225",
                                    "ssqname": "武宣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452226",
                                    "ssqname": "来宾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452227",
                                    "ssqname": "融安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452228",
                                    "ssqname": "三江侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452229",
                                    "ssqname": "融水苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452230",
                                    "ssqname": "金秀瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452231",
                                    "ssqname": "忻城县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "452400",
                        "ssqname": "贺州地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "452402",
                                    "ssqname": "贺州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452424",
                                    "ssqname": "昭平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452427",
                                    "ssqname": "钟山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452428",
                                    "ssqname": "富川瑶族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "452600",
                        "ssqname": "百色地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "452601",
                                    "ssqname": "百色市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452622",
                                    "ssqname": "田阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452623",
                                    "ssqname": "田东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452624",
                                    "ssqname": "平果县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452625",
                                    "ssqname": "德保县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452626",
                                    "ssqname": "靖西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452627",
                                    "ssqname": "那坡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452628",
                                    "ssqname": "凌云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452629",
                                    "ssqname": "乐业县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452630",
                                    "ssqname": "田林县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452631",
                                    "ssqname": "隆林各族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452632",
                                    "ssqname": "西林县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "452700",
                        "ssqname": "河池地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "452701",
                                    "ssqname": "河池市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452702",
                                    "ssqname": "宜州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452723",
                                    "ssqname": "罗城仫佬族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452724",
                                    "ssqname": "环江毛南族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452725",
                                    "ssqname": "南丹县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452726",
                                    "ssqname": "天峨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452727",
                                    "ssqname": "凤山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452728",
                                    "ssqname": "东兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452729",
                                    "ssqname": "巴马瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452730",
                                    "ssqname": "都安瑶族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "452731",
                                    "ssqname": "大化瑶族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "460000",
            "ssqname": "海南省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "460100",
                        "ssqname": "海口市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "460102",
                                    "ssqname": "振东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "460103",
                                    "ssqname": "新华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "460104",
                                    "ssqname": "秀英区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "460200",
                        "ssqname": "三亚市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "460201",
                                "ssqname": "三亚市",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "469000",
                        "ssqname": "直属市县岛屿",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "469001",
                                    "ssqname": "通什市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469002",
                                    "ssqname": "琼海市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469003",
                                    "ssqname": "儋州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469004",
                                    "ssqname": "琼山市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469005",
                                    "ssqname": "文昌市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469006",
                                    "ssqname": "万宁市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469007",
                                    "ssqname": "东方市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469025",
                                    "ssqname": "定安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469026",
                                    "ssqname": "屯昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469027",
                                    "ssqname": "澄迈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469028",
                                    "ssqname": "临高县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469030",
                                    "ssqname": "白沙黎族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469031",
                                    "ssqname": "昌江黎族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469033",
                                    "ssqname": "乐东黎族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469034",
                                    "ssqname": "陵水黎族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469035",
                                    "ssqname": "保亭黎族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469036",
                                    "ssqname": "琼中黎族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469037",
                                    "ssqname": "西沙群岛",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469038",
                                    "ssqname": "南沙群岛",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "469039",
                                    "ssqname": "中沙群岛的岛礁及其海域",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "500000",
            "ssqname": "重庆",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "500100",
                        "ssqname": "市辖区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "500101",
                                    "ssqname": "万州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500102",
                                    "ssqname": "涪陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500103",
                                    "ssqname": "渝中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500104",
                                    "ssqname": "大渡口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500105",
                                    "ssqname": "江北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500106",
                                    "ssqname": "沙坪坝区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500107",
                                    "ssqname": "九龙坡区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500108",
                                    "ssqname": "南岸区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500109",
                                    "ssqname": "北碚区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500110",
                                    "ssqname": "万盛区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500111",
                                    "ssqname": "双桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500112",
                                    "ssqname": "渝北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500113",
                                    "ssqname": "巴南区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500114",
                                    "ssqname": "黔江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500115",
                                    "ssqname": "长寿区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "500200",
                        "ssqname": "市辖县",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "500222",
                                    "ssqname": "綦江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500223",
                                    "ssqname": "潼南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500224",
                                    "ssqname": "铜梁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500225",
                                    "ssqname": "大足县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500226",
                                    "ssqname": "荣昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500227",
                                    "ssqname": "璧山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500228",
                                    "ssqname": "梁平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500229",
                                    "ssqname": "城口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500230",
                                    "ssqname": "丰都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500231",
                                    "ssqname": "垫江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500232",
                                    "ssqname": "武隆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500233",
                                    "ssqname": "忠县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500234",
                                    "ssqname": "开县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500235",
                                    "ssqname": "云阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500236",
                                    "ssqname": "奉节县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500237",
                                    "ssqname": "巫山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500238",
                                    "ssqname": "巫溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500240",
                                    "ssqname": "石柱土家族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500241",
                                    "ssqname": "秀山土家族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500242",
                                    "ssqname": "酉阳土家族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500243",
                                    "ssqname": "彭水苗族土家族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "500300",
                        "ssqname": "县级市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "500381",
                                    "ssqname": "江津市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500382",
                                    "ssqname": "合川市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500383",
                                    "ssqname": "永川市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "500384",
                                    "ssqname": "南川市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "510000",
            "ssqname": "四川省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "510100",
                        "ssqname": "成都市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510104",
                                    "ssqname": "锦江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510105",
                                    "ssqname": "青羊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510106",
                                    "ssqname": "金牛区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510107",
                                    "ssqname": "武侯区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510108",
                                    "ssqname": "成华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510112",
                                    "ssqname": "龙泉驿区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510113",
                                    "ssqname": "青白江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510114",
                                    "ssqname": "新都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510121",
                                    "ssqname": "金堂县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510122",
                                    "ssqname": "双流县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510123",
                                    "ssqname": "温江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510124",
                                    "ssqname": "郫县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510129",
                                    "ssqname": "大邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510131",
                                    "ssqname": "蒲江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510132",
                                    "ssqname": "新津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510181",
                                    "ssqname": "都江堰市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510182",
                                    "ssqname": "彭州市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510183",
                                    "ssqname": "邛崃市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510184",
                                    "ssqname": "崇州市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510300",
                        "ssqname": "自贡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510302",
                                    "ssqname": "自流井区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510303",
                                    "ssqname": "贡井区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510304",
                                    "ssqname": "大安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510311",
                                    "ssqname": "沿滩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510321",
                                    "ssqname": "荣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510322",
                                    "ssqname": "富顺县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510400",
                        "ssqname": "攀枝花市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510402",
                                    "ssqname": "东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510403",
                                    "ssqname": "西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510411",
                                    "ssqname": "仁和区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510421",
                                    "ssqname": "米易县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510422",
                                    "ssqname": "盐边县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510500",
                        "ssqname": "泸州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510502",
                                    "ssqname": "江阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510503",
                                    "ssqname": "纳溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510504",
                                    "ssqname": "龙马潭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510521",
                                    "ssqname": "泸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510522",
                                    "ssqname": "合江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510524",
                                    "ssqname": "叙永县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510525",
                                    "ssqname": "古蔺县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510600",
                        "ssqname": "德阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510603",
                                    "ssqname": "旌阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510623",
                                    "ssqname": "中江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510626",
                                    "ssqname": "罗江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510681",
                                    "ssqname": "广汉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510682",
                                    "ssqname": "什邡市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510683",
                                    "ssqname": "绵竹市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510700",
                        "ssqname": "绵阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510703",
                                    "ssqname": "涪城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510704",
                                    "ssqname": "游仙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510722",
                                    "ssqname": "三台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510723",
                                    "ssqname": "盐亭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510724",
                                    "ssqname": "安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510725",
                                    "ssqname": "梓潼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510726",
                                    "ssqname": "北川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510727",
                                    "ssqname": "平武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510781",
                                    "ssqname": "江油市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510800",
                        "ssqname": "广元市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510802",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510811",
                                    "ssqname": "元坝区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510812",
                                    "ssqname": "朝天区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510821",
                                    "ssqname": "旺苍县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510822",
                                    "ssqname": "青川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510823",
                                    "ssqname": "剑阁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510824",
                                    "ssqname": "苍溪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "510900",
                        "ssqname": "遂宁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "510902",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510921",
                                    "ssqname": "蓬溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510922",
                                    "ssqname": "射洪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "510923",
                                    "ssqname": "大英县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511000",
                        "ssqname": "内江市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511002",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511011",
                                    "ssqname": "东兴区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511024",
                                    "ssqname": "威远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511025",
                                    "ssqname": "资中县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511028",
                                    "ssqname": "隆昌县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511100",
                        "ssqname": "乐山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511102",
                                    "ssqname": "市中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511111",
                                    "ssqname": "沙湾区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511112",
                                    "ssqname": "五通桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511113",
                                    "ssqname": "金口河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511123",
                                    "ssqname": "犍为县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511124",
                                    "ssqname": "井研县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511126",
                                    "ssqname": "夹江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511129",
                                    "ssqname": "沐川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511132",
                                    "ssqname": "峨边彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511133",
                                    "ssqname": "马边彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511181",
                                    "ssqname": "峨眉山市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511300",
                        "ssqname": "南充市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511302",
                                    "ssqname": "顺庆区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511303",
                                    "ssqname": "高坪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511304",
                                    "ssqname": "嘉陵区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511321",
                                    "ssqname": "南部县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511322",
                                    "ssqname": "营山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511323",
                                    "ssqname": "蓬安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511324",
                                    "ssqname": "仪陇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511325",
                                    "ssqname": "西充县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511381",
                                    "ssqname": "阆中市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511400",
                        "ssqname": "眉山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511402",
                                    "ssqname": "东坡区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511421",
                                    "ssqname": "仁寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511422",
                                    "ssqname": "彭山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511423",
                                    "ssqname": "洪雅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511424",
                                    "ssqname": "丹棱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511425",
                                    "ssqname": "青神县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511500",
                        "ssqname": "宜宾市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511502",
                                    "ssqname": "翠屏区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511521",
                                    "ssqname": "宜宾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511522",
                                    "ssqname": "南溪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511523",
                                    "ssqname": "江安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511524",
                                    "ssqname": "长宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511525",
                                    "ssqname": "高县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511526",
                                    "ssqname": "珙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511527",
                                    "ssqname": "筠连县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511528",
                                    "ssqname": "兴文县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511529",
                                    "ssqname": "屏山县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511600",
                        "ssqname": "广安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511602",
                                    "ssqname": "广安区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511621",
                                    "ssqname": "岳池县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511622",
                                    "ssqname": "武胜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511623",
                                    "ssqname": "邻水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511681",
                                    "ssqname": "华莹市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511700",
                        "ssqname": "达州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511702",
                                    "ssqname": "通川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511721",
                                    "ssqname": "达县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511722",
                                    "ssqname": "宣汉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511723",
                                    "ssqname": "开江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511724",
                                    "ssqname": "大竹县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511725",
                                    "ssqname": "渠县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511781",
                                    "ssqname": "万源市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511800",
                        "ssqname": "雅安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511802",
                                    "ssqname": "雨城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511821",
                                    "ssqname": "名山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511822",
                                    "ssqname": "荥经县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511823",
                                    "ssqname": "汉源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511824",
                                    "ssqname": "石棉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511825",
                                    "ssqname": "天全县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511826",
                                    "ssqname": "芦山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511827",
                                    "ssqname": "宝兴县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "511900",
                        "ssqname": "巴中市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "511902",
                                    "ssqname": "巴州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511921",
                                    "ssqname": "通江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511922",
                                    "ssqname": "南江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "511923",
                                    "ssqname": "平昌县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "512000",
                        "ssqname": "资阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "512002",
                                    "ssqname": "雁江区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "512021",
                                    "ssqname": "安岳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "512022",
                                    "ssqname": "乐至县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "512081",
                                    "ssqname": "简阳市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "513200",
                        "ssqname": "阿坝藏族羌族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "513221",
                                    "ssqname": "汶川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513222",
                                    "ssqname": "理县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513223",
                                    "ssqname": "茂县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513224",
                                    "ssqname": "松潘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513225",
                                    "ssqname": "九寨沟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513226",
                                    "ssqname": "金川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513227",
                                    "ssqname": "小金县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513228",
                                    "ssqname": "黑水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513229",
                                    "ssqname": "马尔康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513230",
                                    "ssqname": "壤塘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513231",
                                    "ssqname": "阿坝县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513232",
                                    "ssqname": "若尔盖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513233",
                                    "ssqname": "红原县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "513300",
                        "ssqname": "甘孜藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "513321",
                                    "ssqname": "康定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513322",
                                    "ssqname": "泸定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513323",
                                    "ssqname": "丹巴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513324",
                                    "ssqname": "九龙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513325",
                                    "ssqname": "雅江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513326",
                                    "ssqname": "道孚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513327",
                                    "ssqname": "炉霍县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513328",
                                    "ssqname": "甘孜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513329",
                                    "ssqname": "新龙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513330",
                                    "ssqname": "德格县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513331",
                                    "ssqname": "白玉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513332",
                                    "ssqname": "石渠县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513333",
                                    "ssqname": "色达县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513334",
                                    "ssqname": "理塘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513335",
                                    "ssqname": "巴塘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513336",
                                    "ssqname": "乡城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513337",
                                    "ssqname": "稻城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513338",
                                    "ssqname": "得荣县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "513400",
                        "ssqname": "凉山彝族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "513401",
                                    "ssqname": "西昌市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513422",
                                    "ssqname": "木里藏族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513423",
                                    "ssqname": "盐源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513424",
                                    "ssqname": "德昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513425",
                                    "ssqname": "会理县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513426",
                                    "ssqname": "会东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513427",
                                    "ssqname": "宁南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513428",
                                    "ssqname": "普格县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513429",
                                    "ssqname": "布拖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513430",
                                    "ssqname": "金阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513431",
                                    "ssqname": "昭觉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513432",
                                    "ssqname": "喜德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513433",
                                    "ssqname": "冕宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513434",
                                    "ssqname": "越西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513435",
                                    "ssqname": "甘洛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513436",
                                    "ssqname": "美姑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "513437",
                                    "ssqname": "雷波县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "520000",
            "ssqname": "贵州省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "520100",
                        "ssqname": "贵阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "520102",
                                    "ssqname": "南明区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520103",
                                    "ssqname": "云岩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520111",
                                    "ssqname": "花溪区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520112",
                                    "ssqname": "乌当区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520113",
                                    "ssqname": "白云区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520114",
                                    "ssqname": "小河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520121",
                                    "ssqname": "开阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520122",
                                    "ssqname": "息烽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520123",
                                    "ssqname": "修文县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520181",
                                    "ssqname": "清镇市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "520200",
                        "ssqname": "六盘水市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "520201",
                                    "ssqname": "钟山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520203",
                                    "ssqname": "六枝特区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520221",
                                    "ssqname": "水城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520222",
                                    "ssqname": "盘县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "520300",
                        "ssqname": "遵义市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "520302",
                                    "ssqname": "红花岗区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520321",
                                    "ssqname": "遵义县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520322",
                                    "ssqname": "桐梓县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520323",
                                    "ssqname": "绥阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520324",
                                    "ssqname": "正安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520325",
                                    "ssqname": "道真仡佬族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520326",
                                    "ssqname": "务川仡佬族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520327",
                                    "ssqname": "凤冈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520328",
                                    "ssqname": "湄潭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520329",
                                    "ssqname": "余庆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520330",
                                    "ssqname": "习水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520381",
                                    "ssqname": "赤水市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520382",
                                    "ssqname": "仁怀市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "520400",
                        "ssqname": "安顺市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "520402",
                                    "ssqname": "西秀区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520421",
                                    "ssqname": "平坝县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520422",
                                    "ssqname": "普定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520423",
                                    "ssqname": "镇宁布依族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520424",
                                    "ssqname": "关岭布依族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "520425",
                                    "ssqname": "紫云苗族布依族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "522200",
                        "ssqname": "铜仁地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "522201",
                                    "ssqname": "铜仁市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522222",
                                    "ssqname": "江口县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522223",
                                    "ssqname": "玉屏侗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522224",
                                    "ssqname": "石阡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522225",
                                    "ssqname": "思南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522226",
                                    "ssqname": "印江土家族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522227",
                                    "ssqname": "德江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522228",
                                    "ssqname": "沿河土家族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522229",
                                    "ssqname": "松桃苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522230",
                                    "ssqname": "万山特区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "522300",
                        "ssqname": "黔西南布依族苗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "522301",
                                    "ssqname": "兴义市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522322",
                                    "ssqname": "兴仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522323",
                                    "ssqname": "普安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522324",
                                    "ssqname": "晴隆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522325",
                                    "ssqname": "贞丰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522326",
                                    "ssqname": "望谟县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522327",
                                    "ssqname": "册亨县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522328",
                                    "ssqname": "安龙县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "522400",
                        "ssqname": "毕节地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "522401",
                                    "ssqname": "毕节市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522422",
                                    "ssqname": "大方县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522423",
                                    "ssqname": "黔西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522424",
                                    "ssqname": "金沙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522425",
                                    "ssqname": "织金县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522426",
                                    "ssqname": "纳雍县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522427",
                                    "ssqname": "威宁彝族回族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522428",
                                    "ssqname": "赫章县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "522600",
                        "ssqname": "黔东南苗族侗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "522601",
                                    "ssqname": "凯里市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522622",
                                    "ssqname": "黄平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522623",
                                    "ssqname": "施秉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522624",
                                    "ssqname": "三穗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522625",
                                    "ssqname": "镇远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522626",
                                    "ssqname": "岑巩县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522627",
                                    "ssqname": "天柱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522628",
                                    "ssqname": "锦屏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522629",
                                    "ssqname": "剑河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522630",
                                    "ssqname": "台江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522631",
                                    "ssqname": "黎平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522632",
                                    "ssqname": "榕江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522633",
                                    "ssqname": "从江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522634",
                                    "ssqname": "雷山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522635",
                                    "ssqname": "麻江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522636",
                                    "ssqname": "丹寨县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "522700",
                        "ssqname": "黔南布依族苗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "522701",
                                    "ssqname": "都匀市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522702",
                                    "ssqname": "福泉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522722",
                                    "ssqname": "荔波县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522723",
                                    "ssqname": "贵定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522725",
                                    "ssqname": "瓮安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522726",
                                    "ssqname": "独山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522727",
                                    "ssqname": "平塘县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522728",
                                    "ssqname": "罗甸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522729",
                                    "ssqname": "长顺县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522730",
                                    "ssqname": "龙里县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522731",
                                    "ssqname": "惠水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "522732",
                                    "ssqname": "三都水族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "530000",
            "ssqname": "云南省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "530100",
                        "ssqname": "昆明市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "530102",
                                    "ssqname": "五华区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530103",
                                    "ssqname": "盘龙区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530111",
                                    "ssqname": "官渡区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530112",
                                    "ssqname": "西山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530113",
                                    "ssqname": "东川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530121",
                                    "ssqname": "呈贡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530122",
                                    "ssqname": "晋宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530124",
                                    "ssqname": "富民县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530125",
                                    "ssqname": "宜良县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530126",
                                    "ssqname": "石林彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530127",
                                    "ssqname": "嵩明县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530128",
                                    "ssqname": "禄劝彝族苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530129",
                                    "ssqname": "寻甸回族彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530181",
                                    "ssqname": "安宁市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "530300",
                        "ssqname": "曲靖市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "530302",
                                    "ssqname": "麒麟区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530321",
                                    "ssqname": "马龙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530322",
                                    "ssqname": "陆良县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530323",
                                    "ssqname": "师宗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530324",
                                    "ssqname": "罗平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530325",
                                    "ssqname": "富源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530326",
                                    "ssqname": "会泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530328",
                                    "ssqname": "沾益县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530381",
                                    "ssqname": "宣威市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "530400",
                        "ssqname": "玉溪市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "530402",
                                    "ssqname": "红塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530421",
                                    "ssqname": "江川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530422",
                                    "ssqname": "澄江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530423",
                                    "ssqname": "通海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530424",
                                    "ssqname": "华宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530425",
                                    "ssqname": "易门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530426",
                                    "ssqname": "峨山彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530427",
                                    "ssqname": "新平彝族傣族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530428",
                                    "ssqname": "元江哈尼族彝族傣族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "530500",
                        "ssqname": "保山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "530502",
                                    "ssqname": "隆阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530521",
                                    "ssqname": "施甸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530522",
                                    "ssqname": "腾冲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530523",
                                    "ssqname": "龙陵县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530524",
                                    "ssqname": "昌宁县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "530600",
                        "ssqname": "昭通市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "530602",
                                    "ssqname": "昭阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530621",
                                    "ssqname": "鲁甸县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530622",
                                    "ssqname": "巧家县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530623",
                                    "ssqname": "盐津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530624",
                                    "ssqname": "大关县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530625",
                                    "ssqname": "永善县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530626",
                                    "ssqname": "绥江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530627",
                                    "ssqname": "镇雄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530628",
                                    "ssqname": "彝良县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530629",
                                    "ssqname": "威信县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "530630",
                                    "ssqname": "水富县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532300",
                        "ssqname": "楚雄彝族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532301",
                                    "ssqname": "楚雄市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532322",
                                    "ssqname": "双柏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532323",
                                    "ssqname": "牟定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532324",
                                    "ssqname": "南华县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532325",
                                    "ssqname": "姚安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532326",
                                    "ssqname": "大姚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532327",
                                    "ssqname": "永仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532328",
                                    "ssqname": "元谋县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532329",
                                    "ssqname": "武定县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532331",
                                    "ssqname": "禄丰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532500",
                        "ssqname": "红河哈尼族彝族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532501",
                                    "ssqname": "个旧市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532502",
                                    "ssqname": "开远市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532522",
                                    "ssqname": "蒙自县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532523",
                                    "ssqname": "屏边苗族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532524",
                                    "ssqname": "建水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532525",
                                    "ssqname": "石屏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532526",
                                    "ssqname": "弥勒县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532527",
                                    "ssqname": "泸西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532528",
                                    "ssqname": "元阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532529",
                                    "ssqname": "红河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532530",
                                    "ssqname": "金平苗族瑶族傣族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532531",
                                    "ssqname": "绿春县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532532",
                                    "ssqname": "河口瑶族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532600",
                        "ssqname": "文山壮族苗族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532621",
                                    "ssqname": "文山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532622",
                                    "ssqname": "砚山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532623",
                                    "ssqname": "西畴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532624",
                                    "ssqname": "麻栗坡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532625",
                                    "ssqname": "马关县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532626",
                                    "ssqname": "丘北县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532627",
                                    "ssqname": "广南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532628",
                                    "ssqname": "富宁县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532700",
                        "ssqname": "思茅地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532701",
                                    "ssqname": "思茅市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532722",
                                    "ssqname": "普洱哈尼族彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532723",
                                    "ssqname": "墨江哈尼族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532724",
                                    "ssqname": "景东彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532725",
                                    "ssqname": "景谷傣族彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532726",
                                    "ssqname": "镇沅彝族哈尼族拉祜族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532727",
                                    "ssqname": "江城哈尼族彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532728",
                                    "ssqname": "孟连傣族拉祜族佤族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532729",
                                    "ssqname": "澜沧拉祜族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532730",
                                    "ssqname": "西盟佤族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532800",
                        "ssqname": "西双版纳傣族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532801",
                                    "ssqname": "景洪市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532822",
                                    "ssqname": "勐海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532823",
                                    "ssqname": "勐腊县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "532900",
                        "ssqname": "大理白族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "532901",
                                    "ssqname": "大理市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532922",
                                    "ssqname": "漾濞彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532923",
                                    "ssqname": "祥云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532924",
                                    "ssqname": "宾川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532925",
                                    "ssqname": "弥渡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532926",
                                    "ssqname": "南涧彝族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532927",
                                    "ssqname": "巍山彝族回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532928",
                                    "ssqname": "永平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532929",
                                    "ssqname": "云龙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532930",
                                    "ssqname": "洱源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532931",
                                    "ssqname": "剑川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "532932",
                                    "ssqname": "鹤庆县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "533100",
                        "ssqname": "德宏傣族景颇族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "533102",
                                    "ssqname": "瑞丽市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533103",
                                    "ssqname": "潞西市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533122",
                                    "ssqname": "梁河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533123",
                                    "ssqname": "盈江县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533124",
                                    "ssqname": "陇川县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "533200",
                        "ssqname": "丽江地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "533221",
                                    "ssqname": "丽江纳西族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533222",
                                    "ssqname": "永胜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533223",
                                    "ssqname": "华坪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533224",
                                    "ssqname": "宁蒗彝族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "533300",
                        "ssqname": "怒江傈僳族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "533321",
                                    "ssqname": "泸水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533323",
                                    "ssqname": "福贡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533324",
                                    "ssqname": "贡山独龙族怒族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533325",
                                    "ssqname": "兰坪白族普米族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "533400",
                        "ssqname": "迪庆藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "533421",
                                    "ssqname": "香格里拉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533422",
                                    "ssqname": "德钦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533423",
                                    "ssqname": "维西傈僳族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "533500",
                        "ssqname": "临沧地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "533521",
                                    "ssqname": "临沧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533522",
                                    "ssqname": "凤庆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533523",
                                    "ssqname": "云县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533524",
                                    "ssqname": "永德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533525",
                                    "ssqname": "镇康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533526",
                                    "ssqname": "双江拉祜族佤族布朗族傣族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533527",
                                    "ssqname": "耿马傣族佤族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "533528",
                                    "ssqname": "沧源佤族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "540000",
            "ssqname": "西藏",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "540100",
                        "ssqname": "拉萨市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "540102",
                                    "ssqname": "城关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540121",
                                    "ssqname": "林周县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540122",
                                    "ssqname": "当雄县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540123",
                                    "ssqname": "尼木县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540124",
                                    "ssqname": "曲水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540125",
                                    "ssqname": "堆龙德庆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540126",
                                    "ssqname": "达孜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "540127",
                                    "ssqname": "墨竹工卡县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542100",
                        "ssqname": "昌都地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542121",
                                    "ssqname": "昌都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542122",
                                    "ssqname": "江达县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542123",
                                    "ssqname": "贡觉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542124",
                                    "ssqname": "类乌齐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542125",
                                    "ssqname": "丁青县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542126",
                                    "ssqname": "察雅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542127",
                                    "ssqname": "八宿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542128",
                                    "ssqname": "左贡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542129",
                                    "ssqname": "芒康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542132",
                                    "ssqname": "洛隆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542133",
                                    "ssqname": "边坝县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542200",
                        "ssqname": "山南地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542221",
                                    "ssqname": "乃东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542222",
                                    "ssqname": "扎囊县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542223",
                                    "ssqname": "贡嘎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542224",
                                    "ssqname": "桑日县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542225",
                                    "ssqname": "琼结县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542226",
                                    "ssqname": "曲松县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542227",
                                    "ssqname": "措美县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542228",
                                    "ssqname": "洛扎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542229",
                                    "ssqname": "加查县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542231",
                                    "ssqname": "隆子县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542232",
                                    "ssqname": "错那县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542233",
                                    "ssqname": "浪卡子县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542300",
                        "ssqname": "日喀则地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542301",
                                    "ssqname": "日喀则市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542322",
                                    "ssqname": "南木林县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542323",
                                    "ssqname": "江孜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542324",
                                    "ssqname": "定日县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542325",
                                    "ssqname": "萨迦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542326",
                                    "ssqname": "拉孜县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542327",
                                    "ssqname": "昂仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542328",
                                    "ssqname": "谢通门县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542329",
                                    "ssqname": "白朗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542330",
                                    "ssqname": "仁布县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542331",
                                    "ssqname": "康马县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542332",
                                    "ssqname": "定结县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542333",
                                    "ssqname": "仲巴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542334",
                                    "ssqname": "亚东县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542335",
                                    "ssqname": "吉隆县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542336",
                                    "ssqname": "聂拉木县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542337",
                                    "ssqname": "萨嘎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542338",
                                    "ssqname": "岗巴县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542400",
                        "ssqname": "那曲地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542421",
                                    "ssqname": "那曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542422",
                                    "ssqname": "嘉黎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542423",
                                    "ssqname": "比如县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542424",
                                    "ssqname": "聂荣县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542425",
                                    "ssqname": "安多县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542426",
                                    "ssqname": "申扎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542427",
                                    "ssqname": "索县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542428",
                                    "ssqname": "班戈县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542429",
                                    "ssqname": "巴青县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542430",
                                    "ssqname": "尼玛县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542500",
                        "ssqname": "阿里地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542521",
                                    "ssqname": "普兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542522",
                                    "ssqname": "札达县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542523",
                                    "ssqname": "噶尔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542524",
                                    "ssqname": "日土县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542525",
                                    "ssqname": "革吉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542526",
                                    "ssqname": "改则县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542527",
                                    "ssqname": "措勤县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "542600",
                        "ssqname": "林芝地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "542621",
                                    "ssqname": "林芝县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542622",
                                    "ssqname": "工布江达县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542623",
                                    "ssqname": "米林县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542624",
                                    "ssqname": "墨脱县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542625",
                                    "ssqname": "波密县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542626",
                                    "ssqname": "察隅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "542627",
                                    "ssqname": "朗县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "610000",
            "ssqname": "陕西省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "610100",
                        "ssqname": "西安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610102",
                                    "ssqname": "新城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610103",
                                    "ssqname": "碑林区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610104",
                                    "ssqname": "莲湖区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610111",
                                    "ssqname": "灞桥区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610112",
                                    "ssqname": "未央区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610113",
                                    "ssqname": "雁塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610114",
                                    "ssqname": "阎良区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610115",
                                    "ssqname": "临潼区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610121",
                                    "ssqname": "长安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610122",
                                    "ssqname": "蓝田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610124",
                                    "ssqname": "周至县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610125",
                                    "ssqname": "户县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610126",
                                    "ssqname": "高陵县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610200",
                        "ssqname": "铜川市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610202",
                                    "ssqname": "王益区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610203",
                                    "ssqname": "印台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610221",
                                    "ssqname": "耀县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610222",
                                    "ssqname": "宜君县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610300",
                        "ssqname": "宝鸡市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610302",
                                    "ssqname": "渭滨区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610303",
                                    "ssqname": "金台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610321",
                                    "ssqname": "宝鸡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610322",
                                    "ssqname": "凤翔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610323",
                                    "ssqname": "岐山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610324",
                                    "ssqname": "扶风县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610326",
                                    "ssqname": "眉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610327",
                                    "ssqname": "陇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610328",
                                    "ssqname": "千阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610329",
                                    "ssqname": "麟游县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610330",
                                    "ssqname": "凤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610331",
                                    "ssqname": "太白县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610400",
                        "ssqname": "咸阳市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610402",
                                    "ssqname": "秦都区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610403",
                                    "ssqname": "杨凌区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610404",
                                    "ssqname": "渭城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610422",
                                    "ssqname": "三原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610423",
                                    "ssqname": "泾阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610424",
                                    "ssqname": "乾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610425",
                                    "ssqname": "礼泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610426",
                                    "ssqname": "永寿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610427",
                                    "ssqname": "彬县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610428",
                                    "ssqname": "长武县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610429",
                                    "ssqname": "旬邑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610430",
                                    "ssqname": "淳化县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610431",
                                    "ssqname": "武功县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610481",
                                    "ssqname": "兴平市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610500",
                        "ssqname": "渭南市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610502",
                                    "ssqname": "临渭区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610521",
                                    "ssqname": "华县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610522",
                                    "ssqname": "潼关县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610523",
                                    "ssqname": "大荔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610524",
                                    "ssqname": "合阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610525",
                                    "ssqname": "澄城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610526",
                                    "ssqname": "蒲城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610527",
                                    "ssqname": "白水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610528",
                                    "ssqname": "富平县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610581",
                                    "ssqname": "韩城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610582",
                                    "ssqname": "华阴市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610600",
                        "ssqname": "延安市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610602",
                                    "ssqname": "宝塔区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610621",
                                    "ssqname": "延长县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610622",
                                    "ssqname": "延川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610623",
                                    "ssqname": "子长县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610624",
                                    "ssqname": "安塞县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610625",
                                    "ssqname": "志丹县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610626",
                                    "ssqname": "吴旗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610627",
                                    "ssqname": "甘泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610628",
                                    "ssqname": "富县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610629",
                                    "ssqname": "洛川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610630",
                                    "ssqname": "宜川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610631",
                                    "ssqname": "黄龙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610632",
                                    "ssqname": "黄陵县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610700",
                        "ssqname": "汉中市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610702",
                                    "ssqname": "汉台区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610721",
                                    "ssqname": "南郑县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610722",
                                    "ssqname": "城固县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610723",
                                    "ssqname": "洋县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610724",
                                    "ssqname": "西乡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610725",
                                    "ssqname": "勉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610726",
                                    "ssqname": "宁强县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610727",
                                    "ssqname": "略阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610728",
                                    "ssqname": "镇巴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610729",
                                    "ssqname": "留坝县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610730",
                                    "ssqname": "佛坪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610800",
                        "ssqname": "榆林市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610802",
                                    "ssqname": "榆阳区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610821",
                                    "ssqname": "神木县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610822",
                                    "ssqname": "府谷县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610823",
                                    "ssqname": "横山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610824",
                                    "ssqname": "靖边县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610825",
                                    "ssqname": "定边县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610826",
                                    "ssqname": "绥德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610827",
                                    "ssqname": "米脂县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610828",
                                    "ssqname": "佳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610829",
                                    "ssqname": "吴堡县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610830",
                                    "ssqname": "清涧县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610831",
                                    "ssqname": "子洲县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "610900",
                        "ssqname": "安康市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "610902",
                                    "ssqname": "汉滨区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610921",
                                    "ssqname": "汉阴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610922",
                                    "ssqname": "石泉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610923",
                                    "ssqname": "宁陕县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610924",
                                    "ssqname": "紫阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610925",
                                    "ssqname": "岚皋县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610926",
                                    "ssqname": "平利县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610927",
                                    "ssqname": "镇坪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610928",
                                    "ssqname": "旬阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "610929",
                                    "ssqname": "白河县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "611000",
                        "ssqname": "商洛市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "611002",
                                    "ssqname": "商州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611021",
                                    "ssqname": "洛南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611022",
                                    "ssqname": "丹凤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611023",
                                    "ssqname": "商南县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611024",
                                    "ssqname": "山阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611025",
                                    "ssqname": "镇安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "611026",
                                    "ssqname": "柞水县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "620000",
            "ssqname": "甘肃省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "620100",
                        "ssqname": "兰州市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "620102",
                                    "ssqname": "城关区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620103",
                                    "ssqname": "七里河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620104",
                                    "ssqname": "西固区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620105",
                                    "ssqname": "安宁区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620111",
                                    "ssqname": "红古区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620121",
                                    "ssqname": "永登县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620122",
                                    "ssqname": "皋兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620123",
                                    "ssqname": "榆中县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "620200",
                        "ssqname": "嘉峪关市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "620201",
                                "ssqname": "嘉峪关市",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "620300",
                        "ssqname": "金昌市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "620302",
                                    "ssqname": "金川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620321",
                                    "ssqname": "永昌县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "620400",
                        "ssqname": "白银市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "620402",
                                    "ssqname": "白银区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620403",
                                    "ssqname": "平川区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620421",
                                    "ssqname": "靖远县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620422",
                                    "ssqname": "会宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620423",
                                    "ssqname": "景泰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "620500",
                        "ssqname": "天水市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "620502",
                                    "ssqname": "秦城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620503",
                                    "ssqname": "北道区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620521",
                                    "ssqname": "清水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620522",
                                    "ssqname": "秦安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620523",
                                    "ssqname": "甘谷县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620524",
                                    "ssqname": "武山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620525",
                                    "ssqname": "张家川回族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "620600",
                        "ssqname": "武威市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "620602",
                                    "ssqname": "凉州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620621",
                                    "ssqname": "民勤县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620622",
                                    "ssqname": "古浪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "620623",
                                    "ssqname": "天祝藏族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622100",
                        "ssqname": "酒泉地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622101",
                                    "ssqname": "玉门市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622102",
                                    "ssqname": "酒泉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622103",
                                    "ssqname": "敦煌市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622123",
                                    "ssqname": "金塔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622124",
                                    "ssqname": "肃北蒙古族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622125",
                                    "ssqname": "阿克塞哈萨克族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622126",
                                    "ssqname": "安西县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622200",
                        "ssqname": "张掖地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622201",
                                    "ssqname": "张掖市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622222",
                                    "ssqname": "肃南裕固族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622223",
                                    "ssqname": "民乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622224",
                                    "ssqname": "临泽县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622225",
                                    "ssqname": "高台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622226",
                                    "ssqname": "山丹县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622400",
                        "ssqname": "定西地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622421",
                                    "ssqname": "定西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622424",
                                    "ssqname": "通渭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622425",
                                    "ssqname": "陇西县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622426",
                                    "ssqname": "渭源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622427",
                                    "ssqname": "临洮县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622428",
                                    "ssqname": "漳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622429",
                                    "ssqname": "岷县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622600",
                        "ssqname": "陇南地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622621",
                                    "ssqname": "武都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622623",
                                    "ssqname": "宕昌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622624",
                                    "ssqname": "成县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622625",
                                    "ssqname": "康县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622626",
                                    "ssqname": "文县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622627",
                                    "ssqname": "西和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622628",
                                    "ssqname": "礼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622629",
                                    "ssqname": "两当县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622630",
                                    "ssqname": "徽县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622700",
                        "ssqname": "平凉地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622701",
                                    "ssqname": "平凉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622722",
                                    "ssqname": "泾川县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622723",
                                    "ssqname": "灵台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622724",
                                    "ssqname": "崇信县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622725",
                                    "ssqname": "华亭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622726",
                                    "ssqname": "庄浪县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622727",
                                    "ssqname": "静宁县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622800",
                        "ssqname": "庆阳地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622801",
                                    "ssqname": "西峰市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622821",
                                    "ssqname": "庆阳县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622822",
                                    "ssqname": "环县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622823",
                                    "ssqname": "华池县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622824",
                                    "ssqname": "合水县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622825",
                                    "ssqname": "正宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622826",
                                    "ssqname": "宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622827",
                                    "ssqname": "镇原县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "622900",
                        "ssqname": "临夏回族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "622901",
                                    "ssqname": "临夏市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622921",
                                    "ssqname": "临夏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622922",
                                    "ssqname": "康乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622923",
                                    "ssqname": "永靖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622924",
                                    "ssqname": "广河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622925",
                                    "ssqname": "和政县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622926",
                                    "ssqname": "东乡族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "622927",
                                    "ssqname": "积石山保安族东乡族撒拉族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "623000",
                        "ssqname": "甘南藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "623001",
                                    "ssqname": "合作市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623021",
                                    "ssqname": "临潭县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623022",
                                    "ssqname": "卓尼县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623023",
                                    "ssqname": "舟曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623024",
                                    "ssqname": "迭部县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623025",
                                    "ssqname": "玛曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623026",
                                    "ssqname": "碌曲县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "623027",
                                    "ssqname": "夏河县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "630000",
            "ssqname": "青海省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "630100",
                        "ssqname": "西宁市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "630102",
                                    "ssqname": "城东区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630103",
                                    "ssqname": "城中区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630104",
                                    "ssqname": "城西区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630105",
                                    "ssqname": "城北区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630121",
                                    "ssqname": "大通回族土族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630122",
                                    "ssqname": "湟中县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "630123",
                                    "ssqname": "湟源县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632100",
                        "ssqname": "海东地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632121",
                                    "ssqname": "平安县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632122",
                                    "ssqname": "民和回族土族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632123",
                                    "ssqname": "乐都县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632126",
                                    "ssqname": "互助土族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632127",
                                    "ssqname": "化隆回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632128",
                                    "ssqname": "循化撒拉族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632200",
                        "ssqname": "海北藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632221",
                                    "ssqname": "门源回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632222",
                                    "ssqname": "祁连县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632223",
                                    "ssqname": "海晏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632224",
                                    "ssqname": "刚察县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632300",
                        "ssqname": "黄南藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632321",
                                    "ssqname": "同仁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632322",
                                    "ssqname": "尖扎县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632323",
                                    "ssqname": "泽库县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632324",
                                    "ssqname": "河南蒙古族自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632500",
                        "ssqname": "海南藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632521",
                                    "ssqname": "共和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632522",
                                    "ssqname": "同德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632523",
                                    "ssqname": "贵德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632524",
                                    "ssqname": "兴海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632525",
                                    "ssqname": "贵南县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632600",
                        "ssqname": "果洛藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632621",
                                    "ssqname": "玛沁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632622",
                                    "ssqname": "班玛县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632623",
                                    "ssqname": "甘德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632624",
                                    "ssqname": "达日县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632625",
                                    "ssqname": "久治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632626",
                                    "ssqname": "玛多县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632700",
                        "ssqname": "玉树藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632721",
                                    "ssqname": "玉树县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632722",
                                    "ssqname": "杂多县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632723",
                                    "ssqname": "称多县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632724",
                                    "ssqname": "治多县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632725",
                                    "ssqname": "囊谦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632726",
                                    "ssqname": "曲麻莱县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "632800",
                        "ssqname": "海西蒙古族藏族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "632801",
                                    "ssqname": "格尔木市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632802",
                                    "ssqname": "德令哈市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632821",
                                    "ssqname": "乌兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632822",
                                    "ssqname": "都兰县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "632823",
                                    "ssqname": "天峻县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "640000",
            "ssqname": "宁夏",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "640100",
                        "ssqname": "银川市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "640102",
                                    "ssqname": "城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640103",
                                    "ssqname": "新城区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640111",
                                    "ssqname": "郊区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640121",
                                    "ssqname": "永宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640122",
                                    "ssqname": "贺兰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "640200",
                        "ssqname": "石嘴山市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "640202",
                                    "ssqname": "大武口区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640203",
                                    "ssqname": "石嘴山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640204",
                                    "ssqname": "石炭井区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640221",
                                    "ssqname": "平罗县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640222",
                                    "ssqname": "陶乐县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640223",
                                    "ssqname": "惠农县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "640300",
                        "ssqname": "吴忠市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "640302",
                                    "ssqname": "利通区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640321",
                                    "ssqname": "中卫县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640322",
                                    "ssqname": "中宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640323",
                                    "ssqname": "盐池县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640324",
                                    "ssqname": "同心县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640381",
                                    "ssqname": "青铜峡市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640382",
                                    "ssqname": "灵武市",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "640400",
                        "ssqname": "固原市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "640402",
                                    "ssqname": "原州区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640421",
                                    "ssqname": "海原县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640422",
                                    "ssqname": "西吉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640423",
                                    "ssqname": "隆德县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640424",
                                    "ssqname": "泾源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "640425",
                                    "ssqname": "彭阳县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "650000",
            "ssqname": "新疆",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "650100",
                        "ssqname": "乌鲁木齐市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "650102",
                                    "ssqname": "天山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650103",
                                    "ssqname": "沙依巴克区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650104",
                                    "ssqname": "新市区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650105",
                                    "ssqname": "水磨沟区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650106",
                                    "ssqname": "头屯河区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650107",
                                    "ssqname": "南泉区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650108",
                                    "ssqname": "东山区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650121",
                                    "ssqname": "乌鲁木齐县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "650200",
                        "ssqname": "克拉玛依市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "650202",
                                    "ssqname": "独山子区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650203",
                                    "ssqname": "克拉玛依区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650204",
                                    "ssqname": "白碱滩区",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "650205",
                                    "ssqname": "乌尔禾区",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652100",
                        "ssqname": "吐鲁番地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652101",
                                    "ssqname": "吐鲁番市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652122",
                                    "ssqname": "鄯善县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652123",
                                    "ssqname": "托克逊县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652200",
                        "ssqname": "哈密地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652201",
                                    "ssqname": "哈密市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652222",
                                    "ssqname": "巴里坤哈萨克自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652223",
                                    "ssqname": "伊吾县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652300",
                        "ssqname": "昌吉回族自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652301",
                                    "ssqname": "昌吉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652302",
                                    "ssqname": "阜康市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652303",
                                    "ssqname": "米泉市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652323",
                                    "ssqname": "呼图壁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652324",
                                    "ssqname": "玛纳斯县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652325",
                                    "ssqname": "奇台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652327",
                                    "ssqname": "吉木萨尔县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652328",
                                    "ssqname": "木垒哈萨克自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652700",
                        "ssqname": "博尔塔拉蒙古自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652701",
                                    "ssqname": "博乐市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652722",
                                    "ssqname": "精河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652723",
                                    "ssqname": "温泉县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652800",
                        "ssqname": "巴音郭楞蒙古自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652801",
                                    "ssqname": "库尔勒市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652822",
                                    "ssqname": "轮台县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652823",
                                    "ssqname": "尉犁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652824",
                                    "ssqname": "若羌县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652825",
                                    "ssqname": "且末县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652826",
                                    "ssqname": "焉耆回族自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652827",
                                    "ssqname": "和静县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652828",
                                    "ssqname": "和硕县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652829",
                                    "ssqname": "博湖县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "652900",
                        "ssqname": "阿克苏地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "652901",
                                    "ssqname": "阿克苏市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652922",
                                    "ssqname": "温宿县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652923",
                                    "ssqname": "库车县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652924",
                                    "ssqname": "沙雅县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652925",
                                    "ssqname": "新和县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652926",
                                    "ssqname": "拜城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652927",
                                    "ssqname": "乌什县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652928",
                                    "ssqname": "阿瓦提县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "652929",
                                    "ssqname": "柯坪县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "653000",
                        "ssqname": "克孜勒苏柯尔克孜自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "653001",
                                    "ssqname": "阿图什市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653022",
                                    "ssqname": "阿克陶县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653023",
                                    "ssqname": "阿合奇县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653024",
                                    "ssqname": "乌恰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "653100",
                        "ssqname": "喀什地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "653101",
                                    "ssqname": "喀什市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653121",
                                    "ssqname": "疏附县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653122",
                                    "ssqname": "疏勒县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653123",
                                    "ssqname": "英吉沙县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653124",
                                    "ssqname": "泽普县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653125",
                                    "ssqname": "莎车县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653126",
                                    "ssqname": "叶城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653127",
                                    "ssqname": "麦盖提县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653128",
                                    "ssqname": "岳普湖县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653129",
                                    "ssqname": "伽师县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653130",
                                    "ssqname": "巴楚县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653131",
                                    "ssqname": "塔什库尔干塔吉克自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "653200",
                        "ssqname": "和田地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "653201",
                                    "ssqname": "和田市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653221",
                                    "ssqname": "和田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653222",
                                    "ssqname": "墨玉县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653223",
                                    "ssqname": "皮山县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653224",
                                    "ssqname": "洛浦县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653225",
                                    "ssqname": "策勒县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653226",
                                    "ssqname": "于田县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "653227",
                                    "ssqname": "民丰县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "654000",
                        "ssqname": "伊犁哈萨克自治州",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "654002",
                                    "ssqname": "伊宁市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654003",
                                    "ssqname": "奎屯市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654021",
                                    "ssqname": "伊宁县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654022",
                                    "ssqname": "察布查尔锡伯自治县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654023",
                                    "ssqname": "霍城县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654024",
                                    "ssqname": "巩留县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654025",
                                    "ssqname": "新源县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654026",
                                    "ssqname": "昭苏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654027",
                                    "ssqname": "特克斯县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654028",
                                    "ssqname": "尼勒克县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "654200",
                        "ssqname": "塔城地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "654201",
                                    "ssqname": "塔城市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654202",
                                    "ssqname": "乌苏市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654221",
                                    "ssqname": "额敏县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654223",
                                    "ssqname": "沙湾县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654224",
                                    "ssqname": "托里县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654225",
                                    "ssqname": "裕民县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654226",
                                    "ssqname": "和布克赛尔蒙古自治县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "654300",
                        "ssqname": "阿勒泰地区",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                    "ssqid": "654301",
                                    "ssqname": "阿勒泰市",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654321",
                                    "ssqname": "布尔津县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654322",
                                    "ssqname": "富蕴县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654323",
                                    "ssqname": "福海县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654324",
                                    "ssqname": "哈巴河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654325",
                                    "ssqname": "青河县",
                                    "ssqename": ""
                                },
                                {
                                    "ssqid": "654326",
                                    "ssqname": "吉木乃县",
                                    "ssqename": ""
                                }
                            ]
                        }
                    },
                    {
                        "ssqid": "659000",
                        "ssqname": "县级市",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "659001",
                                "ssqname": "石河子市",
                                "ssqename": ""
                            }]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "710000",
            "ssqname": "香港",
            "ssqename": "",
            "cities": {
                "city": [{
                    "ssqid": "710100",
                    "ssqname": "香港特别行政区",
                    "ssqename": "",
                    "areas": {
                        "area": [{
                            "ssqid": "710101",
                            "ssqname": "香港特别行政区",
                            "ssqename": ""
                        }]
                    }
                }]
            }
        },
        {
            "ssqid": "720000",
            "ssqname": "澳门",
            "ssqename": "",
            "cities": {
                "city": [{
                    "ssqid": "720100",
                    "ssqname": "澳门特别行政区",
                    "ssqename": "",
                    "areas": {
                        "area": [{
                            "ssqid": "720101",
                            "ssqname": "澳门特别行政区",
                            "ssqename": ""
                        }]
                    }
                }]
            }
        },
        {
            "ssqid": "730000",
            "ssqname": "台湾省",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "730100",
                        "ssqname": "台北",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730101",
                                "ssqname": "台北",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730200",
                        "ssqname": "高雄",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730201",
                                "ssqname": "高雄",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730300",
                        "ssqname": "台中",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730301",
                                "ssqname": "台中",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730400",
                        "ssqname": "花莲",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730401",
                                "ssqname": "花莲",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730500",
                        "ssqname": "基隆",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730501",
                                "ssqname": "基隆",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730600",
                        "ssqname": "嘉义",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730601",
                                "ssqname": "嘉义",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730700",
                        "ssqname": "金门",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730701",
                                "ssqname": "金门",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730800",
                        "ssqname": "连江",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730801",
                                "ssqname": "连江",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "730900",
                        "ssqname": "苗栗",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "730901",
                                "ssqname": "苗栗",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731000",
                        "ssqname": "南投",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731001",
                                "ssqname": "南投",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731100",
                        "ssqname": "澎湖",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731101",
                                "ssqname": "澎湖",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731200",
                        "ssqname": "屏东",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731201",
                                "ssqname": "屏东",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731300",
                        "ssqname": "台东",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731301",
                                "ssqname": "台东",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731400",
                        "ssqname": "台南",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731401",
                                "ssqname": "台南",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731500",
                        "ssqname": "桃园",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731501",
                                "ssqname": "桃园",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731600",
                        "ssqname": "新竹",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731601",
                                "ssqname": "新竹",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731700",
                        "ssqname": "宜兰",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731701",
                                "ssqname": "宜兰",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731800",
                        "ssqname": "云林",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731801",
                                "ssqname": "云林",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "731900",
                        "ssqname": "彰化",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "731901",
                                "ssqname": "彰化",
                                "ssqename": ""
                            }]
                        }
                    }
                ]
            }
        },
        {
            "ssqid": "810000",
            "ssqname": "海外",
            "ssqename": "",
            "cities": {
                "city": [{
                        "ssqid": "810100",
                        "ssqname": "美国",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810101",
                                "ssqname": "美国",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810200",
                        "ssqname": "日本",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810201",
                                "ssqname": "日本",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810300",
                        "ssqname": "印度",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810301",
                                "ssqname": "印度",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810400",
                        "ssqname": "巴西",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810401",
                                "ssqname": "巴西",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810500",
                        "ssqname": "阿根廷",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810501",
                                "ssqname": "阿根廷",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810600",
                        "ssqname": "荷兰",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810601",
                                "ssqname": "荷兰",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810700",
                        "ssqname": "德国",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810701",
                                "ssqname": "德国",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810800",
                        "ssqname": "法国",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810801",
                                "ssqname": "法国",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "810900",
                        "ssqname": "瑞士",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "810901",
                                "ssqname": "瑞士",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "811000",
                        "ssqname": "墨西哥",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "811001",
                                "ssqname": "墨西哥",
                                "ssqename": ""
                            }]
                        }
                    },
                    {
                        "ssqid": "811000",
                        "ssqname": "其他",
                        "ssqename": "",
                        "areas": {
                            "area": [{
                                "ssqid": "811001",
                                "ssqname": "其他",
                                "ssqename": ""
                            }]
                        }
                    }
                ]
            }
        }
    ]
}